/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Mssql_Comparison_Exp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: Array<boolean> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: Array<boolean> | null | undefined;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Mssql_Comparison_Exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Mssql_Comparison_Exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Mssql_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _is_null?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

/** Boolean expression to filter rows from the table "clm.engagement_client_comments". All fields are combined with a logical 'AND'. */
export type Clm_Engagement_Client_Comments_Bool_Exp = {
  _and?: Array<Clm_Engagement_Client_Comments_Bool_Exp> | null | undefined;
  _not?: Clm_Engagement_Client_Comments_Bool_Exp | null | undefined;
  _or?: Array<Clm_Engagement_Client_Comments_Bool_Exp> | null | undefined;
  comments?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  created_by?: String_Comparison_Exp | null | undefined;
  engagement_record?: Clm_Engagement_Records_Bool_Exp | null | undefined;
  engagement_records_id?: Uuid_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: String_Comparison_Exp | null | undefined;
};

export type Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp = {
  count?: Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Clm_Engagement_Imanage_Documents_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Clm_Engagement_Imanage_Documents_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** Boolean expression to filter rows from the table "clm.engagement_imanage_documents". All fields are combined with a logical 'AND'. */
export type Clm_Engagement_Imanage_Documents_Bool_Exp = {
  _and?: Array<Clm_Engagement_Imanage_Documents_Bool_Exp> | null | undefined;
  _not?: Clm_Engagement_Imanage_Documents_Bool_Exp | null | undefined;
  _or?: Array<Clm_Engagement_Imanage_Documents_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  created_by?: String_Comparison_Exp | null | undefined;
  doc_id?: String_Comparison_Exp | null | undefined;
  engagement_record?: Clm_Engagement_Records_Bool_Exp | null | undefined;
  engagement_records_id?: Uuid_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: String_Comparison_Exp | null | undefined;
};

/** select columns of table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'doc_id'
  /** column name */
  | 'engagement_records_id'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** Boolean expression to filter rows from the table "clm.engagement_records". All fields are combined with a logical 'AND'. */
export type Clm_Engagement_Records_Bool_Exp = {
  _and?: Array<Clm_Engagement_Records_Bool_Exp> | null | undefined;
  _not?: Clm_Engagement_Records_Bool_Exp | null | undefined;
  _or?: Array<Clm_Engagement_Records_Bool_Exp> | null | undefined;
  client_number?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  created_by?: String_Comparison_Exp | null | undefined;
  engagement_client_comments?: Clm_Engagement_Client_Comments_Bool_Exp | null | undefined;
  engagement_imanage_documents?: Clm_Engagement_Imanage_Documents_Bool_Exp | null | undefined;
  engagement_imanage_documents_aggregate?: Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  type?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: String_Comparison_Exp | null | undefined;
};

export type Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp = {
  count?: Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Clm_Waiver_Imanage_Documents_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Clm_Waiver_Imanage_Documents_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** Boolean expression to filter rows from the table "clm.waiver_imanage_documents". All fields are combined with a logical 'AND'. */
export type Clm_Waiver_Imanage_Documents_Bool_Exp = {
  _and?: Array<Clm_Waiver_Imanage_Documents_Bool_Exp> | null | undefined;
  _not?: Clm_Waiver_Imanage_Documents_Bool_Exp | null | undefined;
  _or?: Array<Clm_Waiver_Imanage_Documents_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  doc_id?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  waiver_record?: Clm_Waiver_Records_Bool_Exp | null | undefined;
  waiver_records_id?: Uuid_Comparison_Exp | null | undefined;
};

/** select columns of table "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'doc_id'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'waiver_records_id';

/** Boolean expression to filter rows from the table "clm.waiver_records". All fields are combined with a logical 'AND'. */
export type Clm_Waiver_Records_Bool_Exp = {
  _and?: Array<Clm_Waiver_Records_Bool_Exp> | null | undefined;
  _not?: Clm_Waiver_Records_Bool_Exp | null | undefined;
  _or?: Array<Clm_Waiver_Records_Bool_Exp> | null | undefined;
  adverse_client_name?: String_Comparison_Exp | null | undefined;
  adverse_contact_signer?: String_Comparison_Exp | null | undefined;
  adverse_letter_date?: Timestamptz_Comparison_Exp | null | undefined;
  adverse_mlb_attorney_on_letter_id?: String_Comparison_Exp | null | undefined;
  adverse_mlb_attorney_on_letter_name?: String_Comparison_Exp | null | undefined;
  client_contact?: String_Comparison_Exp | null | undefined;
  client_letter_date?: Timestamptz_Comparison_Exp | null | undefined;
  client_number?: String_Comparison_Exp | null | undefined;
  comments?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  created_by?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  letter_pending?: String_Comparison_Exp | null | undefined;
  matter_number?: String_Comparison_Exp | null | undefined;
  mlb_attorney_on_client_letter_id?: String_Comparison_Exp | null | undefined;
  mlb_attorney_on_client_letter_name?: String_Comparison_Exp | null | undefined;
  multiple_waivers?: String_Comparison_Exp | null | undefined;
  no_executed_letter_available_of_file?: String_Comparison_Exp | null | undefined;
  no_written_letter_on_file?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: String_Comparison_Exp | null | undefined;
  waiver_imanage_documents?: Clm_Waiver_Imanage_Documents_Bool_Exp | null | undefined;
  waiver_imanage_documents_aggregate?: Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp | null | undefined;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Mssql_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to compare columns of type "datetime2". All fields are combined with logical 'AND'. */
export type Datetime2_Mssql_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to compare columns of type "datetime". All fields are combined with logical 'AND'. */
export type Datetime_Mssql_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.Groups". All fields are combined with a logical 'AND'. */
export type Mlfsl_Ad_Group_Bool_Exp = {
  ADFormatSID?: String_Mssql_Comparison_Exp | null | undefined;
  ADGroupId?: Int_Mssql_Comparison_Exp | null | undefined;
  AcctName?: String_Mssql_Comparison_Exp | null | undefined;
  CN?: String_Mssql_Comparison_Exp | null | undefined;
  ChangedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  ContainsNoMembers?: Boolean_Mssql_Comparison_Exp | null | undefined;
  CreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  DistName?: String_Mssql_Comparison_Exp | null | undefined;
  DomainKey?: Int_Mssql_Comparison_Exp | null | undefined;
  EMail?: String_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  FullDomainName?: String_Mssql_Comparison_Exp | null | undefined;
  Join?: Mlfsl_Ad_Join_Bool_Exp | null | undefined;
  Login?: String_Mssql_Comparison_Exp | null | undefined;
  Mgr?: String_Mssql_Comparison_Exp | null | undefined;
  ModifyTimeStamp?: Datetime_Mssql_Comparison_Exp | null | undefined;
  ObjectGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  RowChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Ad_Group_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Ad_Group_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Ad_Group_Bool_Exp> | null | undefined;
  isDeleted?: Boolean_Mssql_Comparison_Exp | null | undefined;
  isDistributionGroup?: Boolean_Mssql_Comparison_Exp | null | undefined;
  isSecurityGroup?: Boolean_Mssql_Comparison_Exp | null | undefined;
  sid?: Varbinary_Mssql_Comparison_Exp | null | undefined;
  sidText?: String_Mssql_Comparison_Exp | null | undefined;
};

/** order by aggregate values of table "repl.Joins" */
export type Mlfsl_Ad_Join_Aggregate_Order_By = {
  avg?: Mlfsl_Ad_Join_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Ad_Join_Max_Order_By | null | undefined;
  min?: Mlfsl_Ad_Join_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Ad_Join_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Ad_Join_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Ad_Join_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Ad_Join_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Ad_Join_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Ad_Join_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Ad_Join_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Avg_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.Joins". All fields are combined with a logical 'AND'. */
export type Mlfsl_Ad_Join_Bool_Exp = {
  DomainName?: String_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  Group?: Mlfsl_Ad_Group_Bool_Exp | null | undefined;
  GroupObjectGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  GroupsamAccountName?: String_Mssql_Comparison_Exp | null | undefined;
  JoinsRowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  Login?: Mlfsl_Ad_Login_Bool_Exp | null | undefined;
  UserFullName?: String_Mssql_Comparison_Exp | null | undefined;
  UserLogin?: String_Mssql_Comparison_Exp | null | undefined;
  UserObjectGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Ad_Join_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Ad_Join_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Ad_Join_Bool_Exp> | null | undefined;
  isDistributionGroup?: Boolean_Mssql_Comparison_Exp | null | undefined;
  isSecurityGroup?: Boolean_Mssql_Comparison_Exp | null | undefined;
  nestedGroupLevel?: Int_Mssql_Comparison_Exp | null | undefined;
};

/** order by max() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Max_Order_By = {
  DomainName?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  GroupsamAccountName?: Order_By | null | undefined;
  JoinsRowKey?: Order_By | null | undefined;
  UserFullName?: Order_By | null | undefined;
  UserLogin?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Min_Order_By = {
  DomainName?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  GroupsamAccountName?: Order_By | null | undefined;
  JoinsRowKey?: Order_By | null | undefined;
  UserFullName?: Order_By | null | undefined;
  UserLogin?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Stddev_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Stddev_Pop_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Stddev_Samp_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Sum_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Var_Pop_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Var_Samp_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Variance_Order_By = {
  JoinsRowKey?: Order_By | null | undefined;
  nestedGroupLevel?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.Logins". All fields are combined with a logical 'AND'. */
export type Mlfsl_Ad_Login_Bool_Exp = {
  ADFormatSID?: String_Mssql_Comparison_Exp | null | undefined;
  AcctCtrl?: String_Mssql_Comparison_Exp | null | undefined;
  AdLoginId?: Int_Mssql_Comparison_Exp | null | undefined;
  CN?: String_Mssql_Comparison_Exp | null | undefined;
  ChangedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  CreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  Dept?: String_Mssql_Comparison_Exp | null | undefined;
  DistName?: String_Mssql_Comparison_Exp | null | undefined;
  DomainKey?: Int_Mssql_Comparison_Exp | null | undefined;
  EMail?: String_Mssql_Comparison_Exp | null | undefined;
  EmployeeID?: String_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  FirstName?: String_Mssql_Comparison_Exp | null | undefined;
  FullDomainName?: String_Mssql_Comparison_Exp | null | undefined;
  FullDomainUserName?: String_Mssql_Comparison_Exp | null | undefined;
  FullName?: String_Mssql_Comparison_Exp | null | undefined;
  HomeDb?: String_Mssql_Comparison_Exp | null | undefined;
  Info?: String_Mssql_Comparison_Exp | null | undefined;
  Initials?: String_Mssql_Comparison_Exp | null | undefined;
  Join?: Mlfsl_Ad_Join_Bool_Exp | null | undefined;
  LastLogoff?: Datetime2_Mssql_Comparison_Exp | null | undefined;
  LastLogon?: Datetime2_Mssql_Comparison_Exp | null | undefined;
  LastName?: String_Mssql_Comparison_Exp | null | undefined;
  Login?: String_Mssql_Comparison_Exp | null | undefined;
  Mgr?: String_Mssql_Comparison_Exp | null | undefined;
  ModifyTimeStamp?: Datetime_Mssql_Comparison_Exp | null | undefined;
  ObjectGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  Person?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  Phone?: String_Mssql_Comparison_Exp | null | undefined;
  Title?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Ad_Login_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Ad_Login_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Ad_Login_Bool_Exp> | null | undefined;
  businessCategory?: String_Mssql_Comparison_Exp | null | undefined;
  homeDirectory?: String_Mssql_Comparison_Exp | null | undefined;
  isAccountEnabled?: Boolean_Mssql_Comparison_Exp | null | undefined;
  objectCategory?: String_Mssql_Comparison_Exp | null | undefined;
  objectClass?: String_Mssql_Comparison_Exp | null | undefined;
  sid?: Varbinary_Mssql_Comparison_Exp | null | undefined;
};

/** Ordering options when selecting data from "repl.Logins". */
export type Mlfsl_Ad_Login_Order_By = {
  ADFormatSID?: Order_By | null | undefined;
  AcctCtrl?: Order_By | null | undefined;
  AdLoginId?: Order_By | null | undefined;
  CN?: Order_By | null | undefined;
  ChangedDate?: Order_By | null | undefined;
  CreatedDate?: Order_By | null | undefined;
  Dept?: Order_By | null | undefined;
  DistName?: Order_By | null | undefined;
  DomainKey?: Order_By | null | undefined;
  EMail?: Order_By | null | undefined;
  EmployeeID?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  FirstName?: Order_By | null | undefined;
  FullDomainName?: Order_By | null | undefined;
  FullDomainUserName?: Order_By | null | undefined;
  FullName?: Order_By | null | undefined;
  HomeDb?: Order_By | null | undefined;
  Info?: Order_By | null | undefined;
  Initials?: Order_By | null | undefined;
  Join_aggregate?: Mlfsl_Ad_Join_Aggregate_Order_By | null | undefined;
  LastLogoff?: Order_By | null | undefined;
  LastLogon?: Order_By | null | undefined;
  LastName?: Order_By | null | undefined;
  Login?: Order_By | null | undefined;
  Mgr?: Order_By | null | undefined;
  ModifyTimeStamp?: Order_By | null | undefined;
  ObjectGUID?: Order_By | null | undefined;
  Person?: Mlfsl_Personnel_Order_By | null | undefined;
  Phone?: Order_By | null | undefined;
  Title?: Order_By | null | undefined;
  businessCategory?: Order_By | null | undefined;
  homeDirectory?: Order_By | null | undefined;
  isAccountEnabled?: Order_By | null | undefined;
  objectCategory?: Order_By | null | undefined;
  objectClass?: Order_By | null | undefined;
  sid?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimClientNow" */
export type Mlfsl_Client_Aggregate_Order_By = {
  avg?: Mlfsl_Client_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Client_Max_Order_By | null | undefined;
  min?: Mlfsl_Client_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Client_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Client_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Client_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Client_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Client_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Client_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Client_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Avg_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimClientNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Client_Bool_Exp = {
  AdministrativeFlag?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress1?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress2?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress3?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress4?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress5?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress6?: String_Mssql_Comparison_Exp | null | undefined;
  ClientArrangementCode?: String_Mssql_Comparison_Exp | null | undefined;
  ClientArrangementCodeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  ClientCity?: String_Mssql_Comparison_Exp | null | undefined;
  ClientClosedDate?: Mlfsl_Date_Bool_Exp | null | undefined;
  ClientContact?: String_Mssql_Comparison_Exp | null | undefined;
  ClientCountry?: String_Mssql_Comparison_Exp | null | undefined;
  ClientDisplayDescription?: Mlfsl_Client_Display_Description_Bool_Exp | null | undefined;
  ClientGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  ClientIndex?: Int_Mssql_Comparison_Exp | null | undefined;
  ClientName1?: String_Mssql_Comparison_Exp | null | undefined;
  ClientName2?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumberGroupCodeInd?: Boolean_Mssql_Comparison_Exp | null | undefined;
  ClientNumberIwov?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumberNoGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumberWithDash?: String_Mssql_Comparison_Exp | null | undefined;
  ClientOpenDate?: Mlfsl_Date_Bool_Exp | null | undefined;
  ClientPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientPricingNarrative?: String_Mssql_Comparison_Exp | null | undefined;
  ClientReferredBy?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSortName?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSourceAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSourceName?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSourceNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientState?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusCodeActive?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  ClientZipCode?: String_Mssql_Comparison_Exp | null | undefined;
  Confidential?: String_Mssql_Comparison_Exp | null | undefined;
  ConflictsAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  ConflictsAttorneyTKID?: String_Mssql_Comparison_Exp | null | undefined;
  CoordinatingResponsibleAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  CoordinatingResponsibleAttorneyTKID?: String_Mssql_Comparison_Exp | null | undefined;
  DateClientClosed?: Int_Mssql_Comparison_Exp | null | undefined;
  DateClientOpen?: Int_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimClientNowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLSoftInsertIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  IndustryDescription?: String_Mssql_Comparison_Exp | null | undefined;
  InventoryExceptionCode?: String_Mssql_Comparison_Exp | null | undefined;
  InventoryExceptionDescription?: String_Mssql_Comparison_Exp | null | undefined;
  IsClientAllianceProgram?: Int_Mssql_Comparison_Exp | null | undefined;
  LocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStop?: String_Mssql_Comparison_Exp | null | undefined;
  Matters?: Mlfsl_Matter_Bool_Exp | null | undefined;
  MorganNetClientPage_ClientInfo?: Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientName?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  ResponsibleAttorneyTkId?: String_Mssql_Comparison_Exp | null | undefined;
  SecureAlliManageMatterWorkspacesFlag?: String_Mssql_Comparison_Exp | null | undefined;
  SegmentDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SicCodeAndDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SicDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SicTypeCode?: String_Mssql_Comparison_Exp | null | undefined;
  WallBuilderEntityId?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Client_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Client_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Client_Bool_Exp> | null | undefined;
  mlfsl_finance_hours_clientofficetimeframes?: Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_clientpgtimeframes?: Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_clienttimeframes?: Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_clienttimekeepertimeframes?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_matterofficetimeframes?: Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_matterpgtimeframes?: Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimeframecompares?: Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimeframes?: Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp | null | undefined;
  mlfsl_mlv_finance_hours_client?: Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp | null | undefined;
};

/** Boolean expression to filter rows from the table "MLG.Client_DisplayDescription". All fields are combined with a logical 'AND'. */
export type Mlfsl_Client_Display_Description_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ID?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Client_Display_Description_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Client_Display_Description_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Client_Display_Description_Bool_Exp> | null | undefined;
  locationforum?: String_Mssql_Comparison_Exp | null | undefined;
  narrative?: String_Mssql_Comparison_Exp | null | undefined;
};

/** Ordering options when selecting data from "MLG.Client_DisplayDescription". */
export type Mlfsl_Client_Display_Description_Order_By = {
  Client?: Mlfsl_Client_Order_By | null | undefined;
  ID?: Order_By | null | undefined;
  locationforum?: Order_By | null | undefined;
  narrative?: Order_By | null | undefined;
};

/** order by max() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Max_Order_By = {
  AdministrativeFlag?: Order_By | null | undefined;
  ClientAddress1?: Order_By | null | undefined;
  ClientAddress2?: Order_By | null | undefined;
  ClientAddress3?: Order_By | null | undefined;
  ClientAddress4?: Order_By | null | undefined;
  ClientAddress5?: Order_By | null | undefined;
  ClientAddress6?: Order_By | null | undefined;
  ClientArrangementCode?: Order_By | null | undefined;
  ClientArrangementCodeDescription?: Order_By | null | undefined;
  ClientCity?: Order_By | null | undefined;
  ClientContact?: Order_By | null | undefined;
  ClientCountry?: Order_By | null | undefined;
  ClientIndex?: Order_By | null | undefined;
  ClientName1?: Order_By | null | undefined;
  ClientName2?: Order_By | null | undefined;
  ClientNameDisplay?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientNumberIwov?: Order_By | null | undefined;
  ClientNumberNoGroupCode?: Order_By | null | undefined;
  ClientNumberWithDash?: Order_By | null | undefined;
  ClientPhoneNumber?: Order_By | null | undefined;
  ClientPricingNarrative?: Order_By | null | undefined;
  ClientReferredBy?: Order_By | null | undefined;
  ClientSortName?: Order_By | null | undefined;
  ClientSourceAbbreviation?: Order_By | null | undefined;
  ClientSourceName?: Order_By | null | undefined;
  ClientSourceNumber?: Order_By | null | undefined;
  ClientState?: Order_By | null | undefined;
  ClientStatusCode?: Order_By | null | undefined;
  ClientStatusCodeActive?: Order_By | null | undefined;
  ClientStatusDescription?: Order_By | null | undefined;
  ClientZipCode?: Order_By | null | undefined;
  Confidential?: Order_By | null | undefined;
  ConflictsAttorneyTKID?: Order_By | null | undefined;
  CoordinatingResponsibleAttorneyTKID?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IndustryDescription?: Order_By | null | undefined;
  InventoryExceptionCode?: Order_By | null | undefined;
  InventoryExceptionDescription?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  LocationCode?: Order_By | null | undefined;
  MatterStop?: Order_By | null | undefined;
  RelatedClientName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  ResponsibleAttorneyTkId?: Order_By | null | undefined;
  SecureAlliManageMatterWorkspacesFlag?: Order_By | null | undefined;
  SegmentDescription?: Order_By | null | undefined;
  SicCodeAndDescription?: Order_By | null | undefined;
  SicDescription?: Order_By | null | undefined;
  SicTypeCode?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Min_Order_By = {
  AdministrativeFlag?: Order_By | null | undefined;
  ClientAddress1?: Order_By | null | undefined;
  ClientAddress2?: Order_By | null | undefined;
  ClientAddress3?: Order_By | null | undefined;
  ClientAddress4?: Order_By | null | undefined;
  ClientAddress5?: Order_By | null | undefined;
  ClientAddress6?: Order_By | null | undefined;
  ClientArrangementCode?: Order_By | null | undefined;
  ClientArrangementCodeDescription?: Order_By | null | undefined;
  ClientCity?: Order_By | null | undefined;
  ClientContact?: Order_By | null | undefined;
  ClientCountry?: Order_By | null | undefined;
  ClientIndex?: Order_By | null | undefined;
  ClientName1?: Order_By | null | undefined;
  ClientName2?: Order_By | null | undefined;
  ClientNameDisplay?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientNumberIwov?: Order_By | null | undefined;
  ClientNumberNoGroupCode?: Order_By | null | undefined;
  ClientNumberWithDash?: Order_By | null | undefined;
  ClientPhoneNumber?: Order_By | null | undefined;
  ClientPricingNarrative?: Order_By | null | undefined;
  ClientReferredBy?: Order_By | null | undefined;
  ClientSortName?: Order_By | null | undefined;
  ClientSourceAbbreviation?: Order_By | null | undefined;
  ClientSourceName?: Order_By | null | undefined;
  ClientSourceNumber?: Order_By | null | undefined;
  ClientState?: Order_By | null | undefined;
  ClientStatusCode?: Order_By | null | undefined;
  ClientStatusCodeActive?: Order_By | null | undefined;
  ClientStatusDescription?: Order_By | null | undefined;
  ClientZipCode?: Order_By | null | undefined;
  Confidential?: Order_By | null | undefined;
  ConflictsAttorneyTKID?: Order_By | null | undefined;
  CoordinatingResponsibleAttorneyTKID?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IndustryDescription?: Order_By | null | undefined;
  InventoryExceptionCode?: Order_By | null | undefined;
  InventoryExceptionDescription?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  LocationCode?: Order_By | null | undefined;
  MatterStop?: Order_By | null | undefined;
  RelatedClientName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  ResponsibleAttorneyTkId?: Order_By | null | undefined;
  SecureAlliManageMatterWorkspacesFlag?: Order_By | null | undefined;
  SegmentDescription?: Order_By | null | undefined;
  SicCodeAndDescription?: Order_By | null | undefined;
  SicDescription?: Order_By | null | undefined;
  SicTypeCode?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** Ordering options when selecting data from "repl.DimClientNow". */
export type Mlfsl_Client_Order_By = {
  AdministrativeFlag?: Order_By | null | undefined;
  ClientAddress1?: Order_By | null | undefined;
  ClientAddress2?: Order_By | null | undefined;
  ClientAddress3?: Order_By | null | undefined;
  ClientAddress4?: Order_By | null | undefined;
  ClientAddress5?: Order_By | null | undefined;
  ClientAddress6?: Order_By | null | undefined;
  ClientArrangementCode?: Order_By | null | undefined;
  ClientArrangementCodeDescription?: Order_By | null | undefined;
  ClientCity?: Order_By | null | undefined;
  ClientClosedDate?: Mlfsl_Date_Order_By | null | undefined;
  ClientContact?: Order_By | null | undefined;
  ClientCountry?: Order_By | null | undefined;
  ClientDisplayDescription?: Mlfsl_Client_Display_Description_Order_By | null | undefined;
  ClientGUID?: Order_By | null | undefined;
  ClientIndex?: Order_By | null | undefined;
  ClientName1?: Order_By | null | undefined;
  ClientName2?: Order_By | null | undefined;
  ClientNameDisplay?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientNumberGroupCodeInd?: Order_By | null | undefined;
  ClientNumberIwov?: Order_By | null | undefined;
  ClientNumberNoGroupCode?: Order_By | null | undefined;
  ClientNumberWithDash?: Order_By | null | undefined;
  ClientOpenDate?: Mlfsl_Date_Order_By | null | undefined;
  ClientPhoneNumber?: Order_By | null | undefined;
  ClientPricingNarrative?: Order_By | null | undefined;
  ClientReferredBy?: Order_By | null | undefined;
  ClientSortName?: Order_By | null | undefined;
  ClientSourceAbbreviation?: Order_By | null | undefined;
  ClientSourceName?: Order_By | null | undefined;
  ClientSourceNumber?: Order_By | null | undefined;
  ClientState?: Order_By | null | undefined;
  ClientStatusCode?: Order_By | null | undefined;
  ClientStatusCodeActive?: Order_By | null | undefined;
  ClientStatusDescription?: Order_By | null | undefined;
  ClientZipCode?: Order_By | null | undefined;
  Confidential?: Order_By | null | undefined;
  ConflictsAttorney?: Mlfsl_Personnel_Order_By | null | undefined;
  ConflictsAttorneyTKID?: Order_By | null | undefined;
  CoordinatingResponsibleAttorney?: Mlfsl_Personnel_Order_By | null | undefined;
  CoordinatingResponsibleAttorneyTKID?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IndustryDescription?: Order_By | null | undefined;
  InventoryExceptionCode?: Order_By | null | undefined;
  InventoryExceptionDescription?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  LocationCode?: Order_By | null | undefined;
  MatterStop?: Order_By | null | undefined;
  Matters_aggregate?: Mlfsl_Matter_Aggregate_Order_By | null | undefined;
  MorganNetClientPage_ClientInfo?: Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Order_By | null | undefined;
  RelatedClientName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  ResponsibleAttorney?: Mlfsl_Personnel_Order_By | null | undefined;
  ResponsibleAttorneyTkId?: Order_By | null | undefined;
  SecureAlliManageMatterWorkspacesFlag?: Order_By | null | undefined;
  SegmentDescription?: Order_By | null | undefined;
  SicCodeAndDescription?: Order_By | null | undefined;
  SicDescription?: Order_By | null | undefined;
  SicTypeCode?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
  mlfsl_finance_hours_clientofficetimeframes_aggregate?: Mlfsl_Finance_Hours_Clientofficetimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_clientpgtimeframes_aggregate?: Mlfsl_Finance_Hours_Clientpgtimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_clienttimeframes_aggregate?: Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_clienttimekeepertimeframes_aggregate?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_matterofficetimeframes_aggregate?: Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_matterpgtimeframes_aggregate?: Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_mattertimeframecompares_aggregate?: Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_mattertimeframes_aggregate?: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_mlv_finance_hours_client?: Mlfsl_Mlv_Finance_Hours_Client_Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Stddev_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Stddev_Pop_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Stddev_Samp_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Sum_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Var_Pop_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Var_Samp_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Variance_Order_By = {
  ClientIndex?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimDate". All fields are combined with a logical 'AND'. */
export type Mlfsl_Date_Bool_Exp = {
  CalendarDate?: Date_Mssql_Comparison_Exp | null | undefined;
  CalendarQuarter?: Int_Mssql_Comparison_Exp | null | undefined;
  CalendarYear?: Int_Mssql_Comparison_Exp | null | undefined;
  CalendarYearMonth?: String_Mssql_Comparison_Exp | null | undefined;
  CalendarYearQuarter?: String_Mssql_Comparison_Exp | null | undefined;
  CurrentMonthEndDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  DateName?: String_Mssql_Comparison_Exp | null | undefined;
  DayNameOfWeek?: String_Mssql_Comparison_Exp | null | undefined;
  DayOfMonth?: Int_Mssql_Comparison_Exp | null | undefined;
  DayOfWeek?: Int_Mssql_Comparison_Exp | null | undefined;
  DayOfYear?: Int_Mssql_Comparison_Exp | null | undefined;
  DimDatekey?: Int_Mssql_Comparison_Exp | null | undefined;
  FiscalMonthOfYear?: Int_Mssql_Comparison_Exp | null | undefined;
  FiscalQuarter?: Int_Mssql_Comparison_Exp | null | undefined;
  FiscalYear?: Int_Mssql_Comparison_Exp | null | undefined;
  FiscalYearMonth?: String_Mssql_Comparison_Exp | null | undefined;
  FiscalYearQuarter?: String_Mssql_Comparison_Exp | null | undefined;
  FullDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  HolidayBelgiumIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  HolidayBritainIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  HolidayChinaIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  HolidayFranceIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  HolidayGermanyIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  HolidayJapanIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  HolidayUSIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsLastDayOfMonth?: String_Mssql_Comparison_Exp | null | undefined;
  MonthName?: String_Mssql_Comparison_Exp | null | undefined;
  MonthOfYear?: Int_Mssql_Comparison_Exp | null | undefined;
  NextMonthEndDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  PriorMonthEndDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  WeekOfYear?: Int_Mssql_Comparison_Exp | null | undefined;
  WeekdayWeekend?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Date_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Date_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Date_Bool_Exp> | null | undefined;
};

/** Ordering options when selecting data from "repl.DimDate". */
export type Mlfsl_Date_Order_By = {
  CalendarDate?: Order_By | null | undefined;
  CalendarQuarter?: Order_By | null | undefined;
  CalendarYear?: Order_By | null | undefined;
  CalendarYearMonth?: Order_By | null | undefined;
  CalendarYearQuarter?: Order_By | null | undefined;
  CurrentMonthEndDate?: Order_By | null | undefined;
  DateName?: Order_By | null | undefined;
  DayNameOfWeek?: Order_By | null | undefined;
  DayOfMonth?: Order_By | null | undefined;
  DayOfWeek?: Order_By | null | undefined;
  DayOfYear?: Order_By | null | undefined;
  DimDatekey?: Order_By | null | undefined;
  FiscalMonthOfYear?: Order_By | null | undefined;
  FiscalQuarter?: Order_By | null | undefined;
  FiscalYear?: Order_By | null | undefined;
  FiscalYearMonth?: Order_By | null | undefined;
  FiscalYearQuarter?: Order_By | null | undefined;
  FullDate?: Order_By | null | undefined;
  HolidayBelgiumIndicator?: Order_By | null | undefined;
  HolidayBritainIndicator?: Order_By | null | undefined;
  HolidayChinaIndicator?: Order_By | null | undefined;
  HolidayFranceIndicator?: Order_By | null | undefined;
  HolidayGermanyIndicator?: Order_By | null | undefined;
  HolidayJapanIndicator?: Order_By | null | undefined;
  HolidayUSIndicator?: Order_By | null | undefined;
  IsLastDayOfMonth?: Order_By | null | undefined;
  MonthName?: Order_By | null | undefined;
  MonthOfYear?: Order_By | null | undefined;
  NextMonthEndDate?: Order_By | null | undefined;
  PriorMonthEndDate?: Order_By | null | undefined;
  WeekOfYear?: Order_By | null | undefined;
  WeekdayWeekend?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Clientofficetimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Clientofficetimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Clientofficetimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Clientofficetimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Clientofficetimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientOfficeTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  HistoricalTKOfficeforCount?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKOfficeforCount?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKOfficeforCount?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Clientpgtimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Clientpgtimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Clientpgtimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Clientpgtimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Clientpgtimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientPGTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  HistoricalTKPGforCount?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKPGforCount?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKPGforCount?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Clienttimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Clienttimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Clienttimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Clienttimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Clienttimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Clienttimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Clienttimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Avg_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp = {
  BilledAmount?: Float_Mssql_Comparison_Exp | null | undefined;
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientName?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusCategory?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  DaysSinceLastPayment?: Int_Mssql_Comparison_Exp | null | undefined;
  LastPaymentDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  OfficesServingClient?: Int_Mssql_Comparison_Exp | null | undefined;
  PartnersServingClient?: Int_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_ActiveDirectoryLogin?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_Email?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_OfficeEliteLocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_OfficeNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_PracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney_PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  TimeChargesBooked?: Float_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Max_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientName?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientStatusCategory?: Order_By | null | undefined;
  ClientStatusDescription?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  LastPaymentDate?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  ResponsibleAttorney_ActiveDirectoryLogin?: Order_By | null | undefined;
  ResponsibleAttorney_Email?: Order_By | null | undefined;
  ResponsibleAttorney_EmployeeId?: Order_By | null | undefined;
  ResponsibleAttorney_NamePreferredDisplay?: Order_By | null | undefined;
  ResponsibleAttorney_OfficeEliteLocationCode?: Order_By | null | undefined;
  ResponsibleAttorney_OfficeNameDisplay?: Order_By | null | undefined;
  ResponsibleAttorney_PracticeGroupCode?: Order_By | null | undefined;
  ResponsibleAttorney_PracticeGroupName?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Min_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientName?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientStatusCategory?: Order_By | null | undefined;
  ClientStatusDescription?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  LastPaymentDate?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  ResponsibleAttorney_ActiveDirectoryLogin?: Order_By | null | undefined;
  ResponsibleAttorney_Email?: Order_By | null | undefined;
  ResponsibleAttorney_EmployeeId?: Order_By | null | undefined;
  ResponsibleAttorney_NamePreferredDisplay?: Order_By | null | undefined;
  ResponsibleAttorney_OfficeEliteLocationCode?: Order_By | null | undefined;
  ResponsibleAttorney_OfficeNameDisplay?: Order_By | null | undefined;
  ResponsibleAttorney_PracticeGroupCode?: Order_By | null | undefined;
  ResponsibleAttorney_PracticeGroupName?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Pop_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Samp_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Sum_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Var_Pop_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Var_Samp_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Variance_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  OfficesServingClient?: Order_By | null | undefined;
  PartnersServingClient?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientTimekeeperTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  Timekeeper?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  TkprNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_OfficeEliteLocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_OfficeNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_PracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_Role?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_RoleSort?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_TitleDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
  TkprNumber?: Order_By | null | undefined;
  Tkpr_NamePreferredDisplay?: Order_By | null | undefined;
  Tkpr_OfficeEliteLocationCode?: Order_By | null | undefined;
  Tkpr_OfficeNameDisplay?: Order_By | null | undefined;
  Tkpr_PracticeGroupCode?: Order_By | null | undefined;
  Tkpr_PracticeGroupName?: Order_By | null | undefined;
  Tkpr_Role?: Order_By | null | undefined;
  Tkpr_RoleSort?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: Order_By | null | undefined;
  Tkpr_TitleDisplay?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
  TkprNumber?: Order_By | null | undefined;
  Tkpr_NamePreferredDisplay?: Order_By | null | undefined;
  Tkpr_OfficeEliteLocationCode?: Order_By | null | undefined;
  Tkpr_OfficeNameDisplay?: Order_By | null | undefined;
  Tkpr_PracticeGroupCode?: Order_By | null | undefined;
  Tkpr_PracticeGroupName?: Order_By | null | undefined;
  Tkpr_Role?: Order_By | null | undefined;
  Tkpr_RoleSort?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: Order_By | null | undefined;
  Tkpr_TitleDisplay?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Matterofficetimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Matterofficetimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Matterofficetimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Matterofficetimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Matterofficetimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterOfficeTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  HistoricalTKOfficeforCount?: String_Mssql_Comparison_Exp | null | undefined;
  Matter?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp> | null | undefined;
  mlfsl_matter?: Mlfsl_Matter_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKOfficeforCount?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKOfficeforCount?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Matterpgtimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Matterpgtimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Matterpgtimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Matterpgtimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Matterpgtimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterPGTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  HistoricalTKPGforCount?: String_Mssql_Comparison_Exp | null | undefined;
  Matter?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp> | null | undefined;
  mlfsl_matter?: Mlfsl_Matter_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKPGforCount?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  HistoricalTKPGforCount?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Mattertimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Mattertimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Mattertimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Mattertimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Mattertimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Mattertimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Mattertimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Avg_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp = {
  AttorneyInCharge_ActiveDirectoryLogin?: String_Mssql_Comparison_Exp | null | undefined;
  AttorneyInCharge_Email?: String_Mssql_Comparison_Exp | null | undefined;
  AttorneyInCharge_EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  AttorneyInCharge_NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  AttorneyInCharge_PracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  AttorneyInCharge_PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  BilledAmount?: Float_Mssql_Comparison_Exp | null | undefined;
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Matter?: String_Mssql_Comparison_Exp | null | undefined;
  MatterIndustryCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterIndustryCodeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterName?: String_Mssql_Comparison_Exp | null | undefined;
  MatterPracticeCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterPracticeCodeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStatusCategory?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  OfficesServingMatter?: Int_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  TimeChargesBooked?: Float_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  TimekeepersServingMatter?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp> | null | undefined;
  mlfsl_matter?: Mlfsl_Matter_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Max_Order_By = {
  AttorneyInCharge_ActiveDirectoryLogin?: Order_By | null | undefined;
  AttorneyInCharge_Email?: Order_By | null | undefined;
  AttorneyInCharge_EmployeeId?: Order_By | null | undefined;
  AttorneyInCharge_NamePreferredDisplay?: Order_By | null | undefined;
  AttorneyInCharge_PracticeGroupCode?: Order_By | null | undefined;
  AttorneyInCharge_PracticeGroupName?: Order_By | null | undefined;
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  MatterIndustryCode?: Order_By | null | undefined;
  MatterIndustryCodeDescription?: Order_By | null | undefined;
  MatterName?: Order_By | null | undefined;
  MatterPracticeCode?: Order_By | null | undefined;
  MatterPracticeCodeDescription?: Order_By | null | undefined;
  MatterStatusCategory?: Order_By | null | undefined;
  MatterStatusCode?: Order_By | null | undefined;
  MatterStatusDescription?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Min_Order_By = {
  AttorneyInCharge_ActiveDirectoryLogin?: Order_By | null | undefined;
  AttorneyInCharge_Email?: Order_By | null | undefined;
  AttorneyInCharge_EmployeeId?: Order_By | null | undefined;
  AttorneyInCharge_NamePreferredDisplay?: Order_By | null | undefined;
  AttorneyInCharge_PracticeGroupCode?: Order_By | null | undefined;
  AttorneyInCharge_PracticeGroupName?: Order_By | null | undefined;
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  MatterIndustryCode?: Order_By | null | undefined;
  MatterIndustryCodeDescription?: Order_By | null | undefined;
  MatterName?: Order_By | null | undefined;
  MatterPracticeCode?: Order_By | null | undefined;
  MatterPracticeCodeDescription?: Order_By | null | undefined;
  MatterStatusCategory?: Order_By | null | undefined;
  MatterStatusCode?: Order_By | null | undefined;
  MatterStatusDescription?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Pop_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Samp_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Sum_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Var_Pop_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Var_Samp_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Variance_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  OfficesServingMatter?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  TimekeepersServingMatter?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Mattertimeframecompare_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Mattertimeframecompare_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Mattertimeframecompare_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Mattertimeframecompare_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Mattertimeframecompare_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterTimeframeCompare". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  CompareClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  CompareTimeframe?: String_Mssql_Comparison_Exp | null | undefined;
  DifferenceClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  DifferenceClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  Matter?: String_Mssql_Comparison_Exp | null | undefined;
  MatterName?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp> | null | undefined;
  mlfsl_matter?: Mlfsl_Matter_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  CompareTimeframe?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  MatterName?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  CompareTimeframe?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  MatterName?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  ClientBillableHoursPercent?: Order_By | null | undefined;
  CompareClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHours?: Order_By | null | undefined;
  DifferenceClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterTimekeeperTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp = {
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Matter?: String_Mssql_Comparison_Exp | null | undefined;
  MatterBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  Timekeeper?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  TkprNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_OfficeEliteLocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_OfficeNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_PracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_Role?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_RoleSort?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_TitleDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp> | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientOfficeTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp = {
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  HistoricalTKOfficeforCount?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  HistoricalTKOfficeforCount?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  HistoricalTKOfficeforCount?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientPGTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp = {
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  HistoricalTKPGforCount?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  HistoricalTKPGforCount?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  HistoricalTKPGforCount?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Avg_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp = {
  BilledAmount?: Float_Mssql_Comparison_Exp | null | undefined;
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  OfficesServingRelatedClient?: Int_Mssql_Comparison_Exp | null | undefined;
  PartnersServingRelatedClient?: Int_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  TimeChargesBooked?: Float_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Max_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Min_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Pop_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Samp_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Sum_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Pop_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Samp_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Variance_Order_By = {
  BilledAmount?: Order_By | null | undefined;
  ClientBillableHours?: Order_By | null | undefined;
  OfficesServingRelatedClient?: Order_By | null | undefined;
  PartnersServingRelatedClient?: Order_By | null | undefined;
  TimeChargesBooked?: Order_By | null | undefined;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_Order_By = {
  avg?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Max_Order_By | null | undefined;
  min?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Avg_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp = {
  ClientBillableHours?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientBillableHoursPercent?: Float_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Timeframe?: String_Mssql_Comparison_Exp | null | undefined;
  Timekeeper?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  TkprNumber?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_OfficeEliteLocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_OfficeNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_PracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_Role?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_RoleSort?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  Tkpr_TitleDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Max_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
  TkprNumber?: Order_By | null | undefined;
  Tkpr_NamePreferredDisplay?: Order_By | null | undefined;
  Tkpr_OfficeEliteLocationCode?: Order_By | null | undefined;
  Tkpr_OfficeNameDisplay?: Order_By | null | undefined;
  Tkpr_PracticeGroupCode?: Order_By | null | undefined;
  Tkpr_PracticeGroupName?: Order_By | null | undefined;
  Tkpr_Role?: Order_By | null | undefined;
  Tkpr_RoleSort?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: Order_By | null | undefined;
  Tkpr_TitleDisplay?: Order_By | null | undefined;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Min_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  Timeframe?: Order_By | null | undefined;
  TkprNumber?: Order_By | null | undefined;
  Tkpr_NamePreferredDisplay?: Order_By | null | undefined;
  Tkpr_OfficeEliteLocationCode?: Order_By | null | undefined;
  Tkpr_OfficeNameDisplay?: Order_By | null | undefined;
  Tkpr_PracticeGroupCode?: Order_By | null | undefined;
  Tkpr_PracticeGroupName?: Order_By | null | undefined;
  Tkpr_Role?: Order_By | null | undefined;
  Tkpr_RoleSort?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupCode?: Order_By | null | undefined;
  Tkpr_SecondaryPracticeGroupName?: Order_By | null | undefined;
  Tkpr_TitleDisplay?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Sum_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Variance_Order_By = {
  ClientBillableHours?: Order_By | null | undefined;
  RelatedClientBillableHoursPercent?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Aggregate_Order_By = {
  avg?: Mlfsl_Matter_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Matter_Max_Order_By | null | undefined;
  min?: Mlfsl_Matter_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Matter_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Matter_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Matter_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Matter_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Matter_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Matter_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Matter_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Avg_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimMatterNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Matter_Bool_Exp = {
  ABACode?: String_Mssql_Comparison_Exp | null | undefined;
  ABADescription?: String_Mssql_Comparison_Exp | null | undefined;
  AMLID?: Int_Mssql_Comparison_Exp | null | undefined;
  AdministrativeFlag?: String_Mssql_Comparison_Exp | null | undefined;
  AmlClearanceDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  AttorneyInCharge?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  AttorneyInChargeOriginalPracticeGroup?: String_Mssql_Comparison_Exp | null | undefined;
  AttorneyInChargeTkId?: String_Mssql_Comparison_Exp | null | undefined;
  BillingAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  BillingAttorneyTkId?: String_Mssql_Comparison_Exp | null | undefined;
  BillingCoordinator?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  BillingCoordinatorSource?: String_Mssql_Comparison_Exp | null | undefined;
  BillingCoordinatorTkID?: String_Mssql_Comparison_Exp | null | undefined;
  BillingInstructions?: String_Mssql_Comparison_Exp | null | undefined;
  ClassActionIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientReferenceNumber?: String_Mssql_Comparison_Exp | null | undefined;
  DAC6ComplianceIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DateMatterClosed?: Int_Mssql_Comparison_Exp | null | undefined;
  DateMatterOpen?: Int_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimMatterNowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DiscoveryStatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLSoftInsertIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  InventoryExceptionCode?: String_Mssql_Comparison_Exp | null | undefined;
  InventoryExceptionDescription?: String_Mssql_Comparison_Exp | null | undefined;
  LastTimeCardDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  Matter?: String_Mssql_Comparison_Exp | null | undefined;
  MatterAddress1?: String_Mssql_Comparison_Exp | null | undefined;
  MatterAddress2?: String_Mssql_Comparison_Exp | null | undefined;
  MatterAddress3?: String_Mssql_Comparison_Exp | null | undefined;
  MatterAddress4?: String_Mssql_Comparison_Exp | null | undefined;
  MatterAddress5?: String_Mssql_Comparison_Exp | null | undefined;
  MatterAddress6?: String_Mssql_Comparison_Exp | null | undefined;
  MatterArrangementCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterArrangementDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterBillableStatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterBillableStatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterBillableStatusIndicator?: Int_Mssql_Comparison_Exp | null | undefined;
  MatterBillableStatusType?: String_Mssql_Comparison_Exp | null | undefined;
  MatterClosedDate?: Mlfsl_Date_Bool_Exp | null | undefined;
  MatterConfidentialIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  MatterContact?: String_Mssql_Comparison_Exp | null | undefined;
  MatterCurrencyCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterCurrencyCodeChromeRiver?: String_Mssql_Comparison_Exp | null | undefined;
  MatterCurrencyDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterDescription1?: String_Mssql_Comparison_Exp | null | undefined;
  MatterDescription2?: String_Mssql_Comparison_Exp | null | undefined;
  MatterDescription3?: String_Mssql_Comparison_Exp | null | undefined;
  MatterDescriptionFull?: String_Mssql_Comparison_Exp | null | undefined;
  MatterDisplayDescription?: Mlfsl_Matter_Display_Description_Bool_Exp | null | undefined;
  MatterExclusionIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  MatterGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  MatterHoldDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  MatterHoldEndDate?: Date_Mssql_Comparison_Exp | null | undefined;
  MatterHoldStartDate?: Date_Mssql_Comparison_Exp | null | undefined;
  MatterIndex?: Int_Mssql_Comparison_Exp | null | undefined;
  MatterIndustryCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterIndustryCodeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterLocation?: String_Mssql_Comparison_Exp | null | undefined;
  MatterName?: String_Mssql_Comparison_Exp | null | undefined;
  MatterNarrative?: String_Mssql_Comparison_Exp | null | undefined;
  MatterNumber?: String_Mssql_Comparison_Exp | null | undefined;
  MatterOpenDate?: Mlfsl_Date_Bool_Exp | null | undefined;
  MatterPracticeCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterPracticeCodeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterPracticeCodeZeroPadded?: String_Mssql_Comparison_Exp | null | undefined;
  MatterPracticeGroup?: Mlfsl_Practicegroup_Bool_Exp | null | undefined;
  MatterPrivateIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  MatterRateCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterSourceAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  MatterSourceName?: String_Mssql_Comparison_Exp | null | undefined;
  MatterSourceNumber?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStatusOpenIndicator?: Int_Mssql_Comparison_Exp | null | undefined;
  ParallexID?: String_Mssql_Comparison_Exp | null | undefined;
  ProBonoIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  TimeDistributionIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  WallBuilderEntityID?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Matter_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Matter_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Matter_Bool_Exp> | null | undefined;
  mlfsl_finance_hours_matterofficetimeframes?: Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_matterpgtimeframes?: Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimeframecompares?: Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimeframes?: Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimekeepertimeframe?: Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp | null | undefined;
  mlfsl_mlv_finance_hours_matter?: Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp | null | undefined;
};

/** Boolean expression to filter rows from the table "MLG.Matter_DisplayDescription". All fields are combined with a logical 'AND'. */
export type Mlfsl_Matter_Display_Description_Bool_Exp = {
  ID?: String_Mssql_Comparison_Exp | null | undefined;
  Matter?: Mlfsl_Matter_Bool_Exp | null | undefined;
  _and?: Array<Mlfsl_Matter_Display_Description_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Matter_Display_Description_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Matter_Display_Description_Bool_Exp> | null | undefined;
  locationforum?: String_Mssql_Comparison_Exp | null | undefined;
  narrative?: String_Mssql_Comparison_Exp | null | undefined;
};

/** order by max() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Max_Order_By = {
  ABACode?: Order_By | null | undefined;
  ABADescription?: Order_By | null | undefined;
  AMLID?: Order_By | null | undefined;
  AdministrativeFlag?: Order_By | null | undefined;
  AmlClearanceDate?: Order_By | null | undefined;
  AttorneyInChargeOriginalPracticeGroup?: Order_By | null | undefined;
  AttorneyInChargeTkId?: Order_By | null | undefined;
  BillingAttorneyTkId?: Order_By | null | undefined;
  BillingCoordinatorSource?: Order_By | null | undefined;
  BillingCoordinatorTkID?: Order_By | null | undefined;
  BillingInstructions?: Order_By | null | undefined;
  ClassActionIndicator?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientReferenceNumber?: Order_By | null | undefined;
  DAC6ComplianceIndicator?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  DiscoveryStatusCode?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  InventoryExceptionCode?: Order_By | null | undefined;
  InventoryExceptionDescription?: Order_By | null | undefined;
  LastTimeCardDate?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  MatterAddress1?: Order_By | null | undefined;
  MatterAddress2?: Order_By | null | undefined;
  MatterAddress3?: Order_By | null | undefined;
  MatterAddress4?: Order_By | null | undefined;
  MatterAddress5?: Order_By | null | undefined;
  MatterAddress6?: Order_By | null | undefined;
  MatterArrangementCode?: Order_By | null | undefined;
  MatterArrangementDescription?: Order_By | null | undefined;
  MatterBillableStatusCode?: Order_By | null | undefined;
  MatterBillableStatusDescription?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterBillableStatusType?: Order_By | null | undefined;
  MatterConfidentialIndicator?: Order_By | null | undefined;
  MatterContact?: Order_By | null | undefined;
  MatterCurrencyCode?: Order_By | null | undefined;
  MatterCurrencyCodeChromeRiver?: Order_By | null | undefined;
  MatterCurrencyDescription?: Order_By | null | undefined;
  MatterDescription1?: Order_By | null | undefined;
  MatterDescription2?: Order_By | null | undefined;
  MatterDescription3?: Order_By | null | undefined;
  MatterDescriptionFull?: Order_By | null | undefined;
  MatterExclusionIndicator?: Order_By | null | undefined;
  MatterHoldDate?: Order_By | null | undefined;
  MatterHoldEndDate?: Order_By | null | undefined;
  MatterHoldStartDate?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterIndustryCode?: Order_By | null | undefined;
  MatterIndustryCodeDescription?: Order_By | null | undefined;
  MatterLocation?: Order_By | null | undefined;
  MatterName?: Order_By | null | undefined;
  MatterNarrative?: Order_By | null | undefined;
  MatterNumber?: Order_By | null | undefined;
  MatterPracticeCode?: Order_By | null | undefined;
  MatterPracticeCodeDescription?: Order_By | null | undefined;
  MatterPracticeCodeZeroPadded?: Order_By | null | undefined;
  MatterPrivateIndicator?: Order_By | null | undefined;
  MatterRateCode?: Order_By | null | undefined;
  MatterSourceAbbreviation?: Order_By | null | undefined;
  MatterSourceName?: Order_By | null | undefined;
  MatterSourceNumber?: Order_By | null | undefined;
  MatterStatusCode?: Order_By | null | undefined;
  MatterStatusDescription?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  ParallexID?: Order_By | null | undefined;
  ProBonoIndicator?: Order_By | null | undefined;
  TimeDistributionIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Min_Order_By = {
  ABACode?: Order_By | null | undefined;
  ABADescription?: Order_By | null | undefined;
  AMLID?: Order_By | null | undefined;
  AdministrativeFlag?: Order_By | null | undefined;
  AmlClearanceDate?: Order_By | null | undefined;
  AttorneyInChargeOriginalPracticeGroup?: Order_By | null | undefined;
  AttorneyInChargeTkId?: Order_By | null | undefined;
  BillingAttorneyTkId?: Order_By | null | undefined;
  BillingCoordinatorSource?: Order_By | null | undefined;
  BillingCoordinatorTkID?: Order_By | null | undefined;
  BillingInstructions?: Order_By | null | undefined;
  ClassActionIndicator?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientReferenceNumber?: Order_By | null | undefined;
  DAC6ComplianceIndicator?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  DiscoveryStatusCode?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  InventoryExceptionCode?: Order_By | null | undefined;
  InventoryExceptionDescription?: Order_By | null | undefined;
  LastTimeCardDate?: Order_By | null | undefined;
  Matter?: Order_By | null | undefined;
  MatterAddress1?: Order_By | null | undefined;
  MatterAddress2?: Order_By | null | undefined;
  MatterAddress3?: Order_By | null | undefined;
  MatterAddress4?: Order_By | null | undefined;
  MatterAddress5?: Order_By | null | undefined;
  MatterAddress6?: Order_By | null | undefined;
  MatterArrangementCode?: Order_By | null | undefined;
  MatterArrangementDescription?: Order_By | null | undefined;
  MatterBillableStatusCode?: Order_By | null | undefined;
  MatterBillableStatusDescription?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterBillableStatusType?: Order_By | null | undefined;
  MatterConfidentialIndicator?: Order_By | null | undefined;
  MatterContact?: Order_By | null | undefined;
  MatterCurrencyCode?: Order_By | null | undefined;
  MatterCurrencyCodeChromeRiver?: Order_By | null | undefined;
  MatterCurrencyDescription?: Order_By | null | undefined;
  MatterDescription1?: Order_By | null | undefined;
  MatterDescription2?: Order_By | null | undefined;
  MatterDescription3?: Order_By | null | undefined;
  MatterDescriptionFull?: Order_By | null | undefined;
  MatterExclusionIndicator?: Order_By | null | undefined;
  MatterHoldDate?: Order_By | null | undefined;
  MatterHoldEndDate?: Order_By | null | undefined;
  MatterHoldStartDate?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterIndustryCode?: Order_By | null | undefined;
  MatterIndustryCodeDescription?: Order_By | null | undefined;
  MatterLocation?: Order_By | null | undefined;
  MatterName?: Order_By | null | undefined;
  MatterNarrative?: Order_By | null | undefined;
  MatterNumber?: Order_By | null | undefined;
  MatterPracticeCode?: Order_By | null | undefined;
  MatterPracticeCodeDescription?: Order_By | null | undefined;
  MatterPracticeCodeZeroPadded?: Order_By | null | undefined;
  MatterPrivateIndicator?: Order_By | null | undefined;
  MatterRateCode?: Order_By | null | undefined;
  MatterSourceAbbreviation?: Order_By | null | undefined;
  MatterSourceName?: Order_By | null | undefined;
  MatterSourceNumber?: Order_By | null | undefined;
  MatterStatusCode?: Order_By | null | undefined;
  MatterStatusDescription?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  ParallexID?: Order_By | null | undefined;
  ProBonoIndicator?: Order_By | null | undefined;
  TimeDistributionIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Stddev_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Stddev_Pop_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Stddev_Samp_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Sum_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Var_Pop_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Var_Samp_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Variance_Order_By = {
  AMLID?: Order_By | null | undefined;
  DateMatterClosed?: Order_By | null | undefined;
  DateMatterOpen?: Order_By | null | undefined;
  DimMatterNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  MatterBillableStatusIndicator?: Order_By | null | undefined;
  MatterIndex?: Order_By | null | undefined;
  MatterStatusOpenIndicator?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_Client". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClosedMatterCount?: Int_Mssql_Comparison_Exp | null | undefined;
  MatterCount?: Int_Mssql_Comparison_Exp | null | undefined;
  OpenMatterCount?: Int_Mssql_Comparison_Exp | null | undefined;
  TimekeeperCount?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp> | null | undefined;
};

/** Ordering options when selecting data from "MNET.mlv_Finance_Hours_Client". */
export type Mlfsl_Mlv_Finance_Hours_Client_Order_By = {
  Client?: Mlfsl_Client_Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClosedMatterCount?: Order_By | null | undefined;
  MatterCount?: Order_By | null | undefined;
  OpenMatterCount?: Order_By | null | undefined;
  TimekeeperCount?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_Matter". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp = {
  Matter?: Mlfsl_Matter_Bool_Exp | null | undefined;
  MatterNumber?: String_Mssql_Comparison_Exp | null | undefined;
  TimekeeperCount?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp> | null | undefined;
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_RelatedClient". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp = {
  ActiveClientCount?: Int_Mssql_Comparison_Exp | null | undefined;
  ClientCount?: Int_Mssql_Comparison_Exp | null | undefined;
  InactiveClientCount?: Int_Mssql_Comparison_Exp | null | undefined;
  MatterCount?: Int_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  TimekeeperCount?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp> | null | undefined;
};

/** Ordering options when selecting data from "MNET.mlv_Finance_Hours_RelatedClient". */
export type Mlfsl_Mlv_Finance_Hours_Relatedclient_Order_By = {
  ActiveClientCount?: Order_By | null | undefined;
  ClientCount?: Order_By | null | undefined;
  InactiveClientCount?: Order_By | null | undefined;
  MatterCount?: Order_By | null | undefined;
  RelatedClient?: Mlfsl_Related_Client_Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  TimekeeperCount?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.MorganNetClientPage_ClientInfo". All fields are combined with a logical 'AND'. */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp = {
  Client?: Mlfsl_Client_Bool_Exp | null | undefined;
  ClientCloseDate?: Date_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientOpenDate?: Date_Mssql_Comparison_Exp | null | undefined;
  DUNSNumber?: String_Mssql_Comparison_Exp | null | undefined;
  DUNSNumber_DomesticUltimate?: String_Mssql_Comparison_Exp | null | undefined;
  DUNSNumber_GlobalUltimate?: String_Mssql_Comparison_Exp | null | undefined;
  DUNSNumber_Headquarters?: String_Mssql_Comparison_Exp | null | undefined;
  DaysSinceLastPayment?: Int_Mssql_Comparison_Exp | null | undefined;
  LastPaymentAmount?: Float_Mssql_Comparison_Exp | null | undefined;
  LastPaymentDate?: Date_Mssql_Comparison_Exp | null | undefined;
  MNCP_ClientInfoKey?: Int_Mssql_Comparison_Exp | null | undefined;
  MattersOverARLimit?: Int_Mssql_Comparison_Exp | null | undefined;
  MattersOverUBTLimit?: Int_Mssql_Comparison_Exp | null | undefined;
  NumberMattersOpenedLast14Days?: Int_Mssql_Comparison_Exp | null | undefined;
  RelatedClient?: Mlfsl_Client_Bool_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp> | null | undefined;
};

/** Ordering options when selecting data from "repl.MorganNetClientPage_ClientInfo". */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By = {
  Client?: Mlfsl_Client_Order_By | null | undefined;
  ClientCloseDate?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientOpenDate?: Order_By | null | undefined;
  DUNSNumber?: Order_By | null | undefined;
  DUNSNumber_DomesticUltimate?: Order_By | null | undefined;
  DUNSNumber_GlobalUltimate?: Order_By | null | undefined;
  DUNSNumber_Headquarters?: Order_By | null | undefined;
  DaysSinceLastPayment?: Order_By | null | undefined;
  LastPaymentAmount?: Order_By | null | undefined;
  LastPaymentDate?: Order_By | null | undefined;
  MNCP_ClientInfoKey?: Order_By | null | undefined;
  MattersOverARLimit?: Order_By | null | undefined;
  MattersOverUBTLimit?: Order_By | null | undefined;
  NumberMattersOpenedLast14Days?: Order_By | null | undefined;
  RelatedClient?: Mlfsl_Client_Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimOfficeNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Office_Bool_Exp = {
  BusinessPrimaryOfficePersonnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  BusinessSecondaryOfficePersonnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  DataCenterRegion?: String_Mssql_Comparison_Exp | null | undefined;
  DatabaseName?: String_Mssql_Comparison_Exp | null | undefined;
  DatabaseServer?: String_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimOfficeNowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  OfficeActiveFlag?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeAddress1?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeAddress2?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeAddress3?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeAddress4?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeCity?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeCountryCode?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeCountryName?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeCurrencyCode?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeEliteLocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeFax?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  OfficeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeGroupDescription?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeInternalPhonePrefix?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeLocationAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeManagerEmail?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeManagerEmployeeID?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeManagerNameFull?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeName?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  OfficePhone?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeRegion?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeSignatureText?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeState?: String_Mssql_Comparison_Exp | null | undefined;
  OfficeZipCode?: String_Mssql_Comparison_Exp | null | undefined;
  RegionalFirmName?: String_Mssql_Comparison_Exp | null | undefined;
  WorkCalendarCode?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Office_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Office_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Office_Bool_Exp> | null | undefined;
};

/** Ordering options when selecting data from "repl.DimOfficeNow". */
export type Mlfsl_Office_Order_By = {
  BusinessPrimaryOfficePersonnel_aggregate?: Mlfsl_Personnel_Aggregate_Order_By | null | undefined;
  BusinessSecondaryOfficePersonnel_aggregate?: Mlfsl_Personnel_Aggregate_Order_By | null | undefined;
  DataCenterRegion?: Order_By | null | undefined;
  DatabaseName?: Order_By | null | undefined;
  DatabaseServer?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimOfficeNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  OfficeActiveFlag?: Order_By | null | undefined;
  OfficeAddress1?: Order_By | null | undefined;
  OfficeAddress2?: Order_By | null | undefined;
  OfficeAddress3?: Order_By | null | undefined;
  OfficeAddress4?: Order_By | null | undefined;
  OfficeCity?: Order_By | null | undefined;
  OfficeCountryCode?: Order_By | null | undefined;
  OfficeCountryName?: Order_By | null | undefined;
  OfficeCurrencyCode?: Order_By | null | undefined;
  OfficeEliteLocationCode?: Order_By | null | undefined;
  OfficeFax?: Order_By | null | undefined;
  OfficeGUID?: Order_By | null | undefined;
  OfficeGroupCode?: Order_By | null | undefined;
  OfficeGroupDescription?: Order_By | null | undefined;
  OfficeInternalPhonePrefix?: Order_By | null | undefined;
  OfficeLocationAbbreviation?: Order_By | null | undefined;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: Order_By | null | undefined;
  OfficeManagerEmail?: Order_By | null | undefined;
  OfficeManagerEmployeeID?: Order_By | null | undefined;
  OfficeManagerNameFull?: Order_By | null | undefined;
  OfficeName?: Order_By | null | undefined;
  OfficeNameDisplay?: Order_By | null | undefined;
  OfficePhone?: Order_By | null | undefined;
  OfficeRegion?: Order_By | null | undefined;
  OfficeSignatureText?: Order_By | null | undefined;
  OfficeState?: Order_By | null | undefined;
  OfficeZipCode?: Order_By | null | undefined;
  RegionalFirmName?: Order_By | null | undefined;
  WorkCalendarCode?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Aggregate_Order_By = {
  avg?: Mlfsl_Person_Education_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Person_Education_Max_Order_By | null | undefined;
  min?: Mlfsl_Person_Education_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Person_Education_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Person_Education_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Person_Education_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Person_Education_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Person_Education_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Person_Education_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Person_Education_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Avg_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelEducation". All fields are combined with a logical 'AND'. */
export type Mlfsl_Person_Education_Bool_Exp = {
  CompletionDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  DegreeCode?: String_Mssql_Comparison_Exp | null | undefined;
  DegreeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  DimPersonnelEducationKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  GraduationYear?: String_Mssql_Comparison_Exp | null | undefined;
  Honors?: String_Mssql_Comparison_Exp | null | undefined;
  InProgress?: String_Mssql_Comparison_Exp | null | undefined;
  IsDeletedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  LawsonCreationDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  Personnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  SchoolCode?: String_Mssql_Comparison_Exp | null | undefined;
  SchoolDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SchoolType?: String_Mssql_Comparison_Exp | null | undefined;
  SubjectCode?: String_Mssql_Comparison_Exp | null | undefined;
  SubjectDescription?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Person_Education_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Person_Education_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Person_Education_Bool_Exp> | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Max_Order_By = {
  CompletionDate?: Order_By | null | undefined;
  DegreeCode?: Order_By | null | undefined;
  DegreeDescription?: Order_By | null | undefined;
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  GraduationYear?: Order_By | null | undefined;
  Honors?: Order_By | null | undefined;
  InProgress?: Order_By | null | undefined;
  IsDeletedIndicator?: Order_By | null | undefined;
  LawsonCreationDate?: Order_By | null | undefined;
  SchoolCode?: Order_By | null | undefined;
  SchoolDescription?: Order_By | null | undefined;
  SchoolType?: Order_By | null | undefined;
  SubjectCode?: Order_By | null | undefined;
  SubjectDescription?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Min_Order_By = {
  CompletionDate?: Order_By | null | undefined;
  DegreeCode?: Order_By | null | undefined;
  DegreeDescription?: Order_By | null | undefined;
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  GraduationYear?: Order_By | null | undefined;
  Honors?: Order_By | null | undefined;
  InProgress?: Order_By | null | undefined;
  IsDeletedIndicator?: Order_By | null | undefined;
  LawsonCreationDate?: Order_By | null | undefined;
  SchoolCode?: Order_By | null | undefined;
  SchoolDescription?: Order_By | null | undefined;
  SchoolType?: Order_By | null | undefined;
  SubjectCode?: Order_By | null | undefined;
  SubjectDescription?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Stddev_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Stddev_Pop_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Stddev_Samp_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Sum_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Var_Pop_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Var_Samp_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Variance_Order_By = {
  DimPersonnelEducationKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Aggregate_Order_By = {
  avg?: Mlfsl_Personnel_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Personnel_Max_Order_By | null | undefined;
  min?: Mlfsl_Personnel_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Personnel_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Personnel_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Personnel_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Personnel_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Personnel_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Personnel_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Personnel_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Avg_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Aggregate_Order_By = {
  avg?: Mlfsl_Personnel_Bar_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Personnel_Bar_Max_Order_By | null | undefined;
  min?: Mlfsl_Personnel_Bar_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Personnel_Bar_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Personnel_Bar_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Personnel_Bar_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Personnel_Bar_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Personnel_Bar_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Personnel_Bar_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Personnel_Bar_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Avg_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelBar". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Bar_Bool_Exp = {
  Bar?: String_Mssql_Comparison_Exp | null | undefined;
  BarId?: String_Mssql_Comparison_Exp | null | undefined;
  BarYear?: String_Mssql_Comparison_Exp | null | undefined;
  DimPersonnelBarKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  IsDeletedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Personnel_Bar_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Personnel_Bar_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Personnel_Bar_Bool_Exp> | null | undefined;
  mlfsl_personnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Max_Order_By = {
  Bar?: Order_By | null | undefined;
  BarId?: Order_By | null | undefined;
  BarYear?: Order_By | null | undefined;
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IsDeletedIndicator?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Min_Order_By = {
  Bar?: Order_By | null | undefined;
  BarId?: Order_By | null | undefined;
  BarYear?: Order_By | null | undefined;
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IsDeletedIndicator?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Stddev_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Stddev_Pop_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Stddev_Samp_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Sum_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Var_Pop_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Var_Samp_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Variance_Order_By = {
  DimPersonnelBarKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Bool_Exp = {
  ActiveDirectoryBusinessCategory?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectoryDisabledIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectoryDistinguishedName?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectoryEmail?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectoryHomeDirectory?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectoryLogin?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectoryMailboxIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  ActiveDirectorySEVDepartedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  BYODIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  BarAdmissionFirst?: String_Mssql_Comparison_Exp | null | undefined;
  BardateFirst?: Datetime_Mssql_Comparison_Exp | null | undefined;
  BillingCoordinatorEmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  BlackberryPin?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeAddress1?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeAddress2?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeAddress3?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeCity?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeCode?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeCountryCode?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeState?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPostalOfficeZip?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOffice?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeAddress1?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeAddress2?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeAddress3?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeAddress4?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeCity?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeCode?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeCodeNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeCodeNumberWithExtension?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeCountryCode?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeMailBoxNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeMailGroup?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeMailGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficePhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficePhoneExtension?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficePhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficePhoneNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeState?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessPrimaryOfficeZip?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOffice?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficeCode?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficeCodeNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficeCodeNumberWithExtension?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficePhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficePhoneExtension?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficePhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficePhoneNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: String_Mssql_Comparison_Exp | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  CellPhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  CellPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  CellPhoneNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  DataCenterRegion?: String_Mssql_Comparison_Exp | null | undefined;
  DataSource?: String_Mssql_Comparison_Exp | null | undefined;
  DateAccessRemoveKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateAssociationKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateBirthKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateCounselKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateHire?: Mlfsl_Date_Bool_Exp | null | undefined;
  DateHireAdjusted?: Mlfsl_Date_Bool_Exp | null | undefined;
  DateHireAdjustedKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateHireKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateOfCounselKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DatePartnershipKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateRehireExpirationKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateRehireKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateRemoteWorkingProgramKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateSeniorCounselKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateSpecialCounselKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateTerm?: Mlfsl_Date_Bool_Exp | null | undefined;
  DateTermKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DateinternationalPartnerKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DesignatedEssentialWorkerIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimPersonnelNowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  DiscoveryFlag?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLSoftInsertIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  ElitePracticeArea?: String_Mssql_Comparison_Exp | null | undefined;
  ElitePracticeAreaDelimited?: String_Mssql_Comparison_Exp | null | undefined;
  EliteStatus?: String_Mssql_Comparison_Exp | null | undefined;
  EliteSubSubPracticeGroup?: String_Mssql_Comparison_Exp | null | undefined;
  EliteTimekeepLocation?: String_Mssql_Comparison_Exp | null | undefined;
  EliteTitle?: String_Mssql_Comparison_Exp | null | undefined;
  EliteTitleSortOrder?: Int_Mssql_Comparison_Exp | null | undefined;
  EliteWorkLocation?: String_Mssql_Comparison_Exp | null | undefined;
  ElitedateHireKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ElitedateTermKey?: Int_Mssql_Comparison_Exp | null | undefined;
  Email?: String_Mssql_Comparison_Exp | null | undefined;
  EmailSignatureCaveatText?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1FirstName?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1HomePhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1HomePhoneFull?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1HomePhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1LastName?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1MiddleName?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1NameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1NameFull?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1WorkPhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1WorkPhoneExtension?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1WorkPhoneFull?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact1WorkPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2FirstName?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2HomePhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2HomePhoneFull?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2HomePhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2LastName?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2MiddleName?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2NameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2NameFull?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2WorkPhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2WorkPhoneExtension?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2WorkPhoneFull?: String_Mssql_Comparison_Exp | null | undefined;
  EmergencyContact2WorkPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  EmployeeCategoryCode?: String_Mssql_Comparison_Exp | null | undefined;
  EmployeeCategoryDescription?: String_Mssql_Comparison_Exp | null | undefined;
  EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  EmployeeTypeFlag?: String_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreateddate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifieddate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  FullTimeEquivalency?: Float_Mssql_Comparison_Exp | null | undefined;
  Gender?: String_Mssql_Comparison_Exp | null | undefined;
  GenderDescription?: String_Mssql_Comparison_Exp | null | undefined;
  GradClassYear?: String_Mssql_Comparison_Exp | null | undefined;
  GroupJoins?: Mlfsl_Ad_Join_Bool_Exp | null | undefined;
  IsActiveIndicator?: Int_Mssql_Comparison_Exp | null | undefined;
  IsBilledByAIC?: String_Mssql_Comparison_Exp | null | undefined;
  IsDMSDenyAccess?: String_Mssql_Comparison_Exp | null | undefined;
  IsExemptIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHRCellPhoneUnlistedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHREducationYearUnlistedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHRHomeAddressUnlistedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHRHomePhoneUnlistedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHRSpouseUnlistedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHrDefinedAttorneyIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsHrUnlistedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  IsLateralAttorney?: String_Mssql_Comparison_Exp | null | undefined;
  IsLegalProfessionalIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  JobCode?: String_Mssql_Comparison_Exp | null | undefined;
  JobFamily?: String_Mssql_Comparison_Exp | null | undefined;
  JobFamilyGroup?: String_Mssql_Comparison_Exp | null | undefined;
  LawsonCompany?: Int_Mssql_Comparison_Exp | null | undefined;
  LawsonFullTimeEquivalency?: Float_Mssql_Comparison_Exp | null | undefined;
  LawsonSecondarySubSubPracticeGroup?: String_Mssql_Comparison_Exp | null | undefined;
  LawsonSubSubPracticeGroup?: String_Mssql_Comparison_Exp | null | undefined;
  LawsondateHireAdjustedKey?: Int_Mssql_Comparison_Exp | null | undefined;
  LawsondateHireKey?: Int_Mssql_Comparison_Exp | null | undefined;
  LawsondateTermKey?: Int_Mssql_Comparison_Exp | null | undefined;
  Login?: Mlfsl_Ad_Login_Bool_Exp | null | undefined;
  MLBClassYear?: String_Mssql_Comparison_Exp | null | undefined;
  Manager1EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Manager1EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Manager2EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Manager2EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Manager3EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Manager3EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Manager4EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Manager4EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Manager5EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Manager5EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Manager6EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Manager6EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  MarsPersonID?: Int_Mssql_Comparison_Exp | null | undefined;
  MarsSubSubPracticeGroup?: String_Mssql_Comparison_Exp | null | undefined;
  MarsTitle?: String_Mssql_Comparison_Exp | null | undefined;
  MarsWorkLocation?: String_Mssql_Comparison_Exp | null | undefined;
  MorganNetDisplayIndicator?: Int_Mssql_Comparison_Exp | null | undefined;
  NameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  NameFirst?: String_Mssql_Comparison_Exp | null | undefined;
  NameFirstBilling?: String_Mssql_Comparison_Exp | null | undefined;
  NameFull?: String_Mssql_Comparison_Exp | null | undefined;
  NameInitialsElite?: String_Mssql_Comparison_Exp | null | undefined;
  NameLast?: String_Mssql_Comparison_Exp | null | undefined;
  NameLastBilling?: String_Mssql_Comparison_Exp | null | undefined;
  NameLastNoSuffix?: String_Mssql_Comparison_Exp | null | undefined;
  NameMaidenFirst?: String_Mssql_Comparison_Exp | null | undefined;
  NameMaidenLast?: String_Mssql_Comparison_Exp | null | undefined;
  NameMaidenMiddleInitial?: String_Mssql_Comparison_Exp | null | undefined;
  NameMiddle?: String_Mssql_Comparison_Exp | null | undefined;
  NameMiddleInitial?: String_Mssql_Comparison_Exp | null | undefined;
  NameNick?: String_Mssql_Comparison_Exp | null | undefined;
  NameNickIa?: String_Mssql_Comparison_Exp | null | undefined;
  NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  NamePreferredDisplay_?: String_Mssql_Comparison_Exp | null | undefined;
  NamePreferredFirst?: String_Mssql_Comparison_Exp | null | undefined;
  NamePreferredFull?: String_Mssql_Comparison_Exp | null | undefined;
  NamePreferredLast?: String_Mssql_Comparison_Exp | null | undefined;
  NamePreferredMiddle?: String_Mssql_Comparison_Exp | null | undefined;
  NameSuffix?: String_Mssql_Comparison_Exp | null | undefined;
  NameTDDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  NonFirmOfficeTaxJurisdictionResident?: String_Mssql_Comparison_Exp | null | undefined;
  NonPhiladelphiaResident?: String_Mssql_Comparison_Exp | null | undefined;
  ParalegalTier?: String_Mssql_Comparison_Exp | null | undefined;
  PartnerTypeKey?: Int_Mssql_Comparison_Exp | null | undefined;
  PayrollBatchId?: String_Mssql_Comparison_Exp | null | undefined;
  PayrollFileNumber?: String_Mssql_Comparison_Exp | null | undefined;
  PayrollPayGroup?: String_Mssql_Comparison_Exp | null | undefined;
  PersonEducation?: Mlfsl_Person_Education_Bool_Exp | null | undefined;
  PersonalAddressFour?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalAddressOne?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalAddressThree?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalAddressTwo?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalCity?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalCountry?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalEmailAddress?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalMatter?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalPhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalPhoneNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalPronouns?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalSecondPhoneCountry?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalSecondPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalSecondPhoneNumberFull?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalState?: String_Mssql_Comparison_Exp | null | undefined;
  PersonalZip?: String_Mssql_Comparison_Exp | null | undefined;
  PersonnelSourceAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  PersonnelSourceName?: String_Mssql_Comparison_Exp | null | undefined;
  PersonnelSourceNumber?: String_Mssql_Comparison_Exp | null | undefined;
  PictureURL?: String_Mssql_Comparison_Exp | null | undefined;
  PrimaryAssistant?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  PrimaryOffice?: Mlfsl_Office_Bool_Exp | null | undefined;
  PrimaryPracticeGroup?: Mlfsl_Practicegroup_Bool_Exp | null | undefined;
  RateBilling?: Float_Mssql_Comparison_Exp | null | undefined;
  RateGrid?: Float_Mssql_Comparison_Exp | null | undefined;
  RateStandard?: Float_Mssql_Comparison_Exp | null | undefined;
  RehireIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  RemoteWorkingProgramIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  RequiredTime?: String_Mssql_Comparison_Exp | null | undefined;
  SecondaryAssistant?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  SecondaryOffice?: Mlfsl_Office_Bool_Exp | null | undefined;
  SecondaryPracticeGroup?: Mlfsl_Practicegroup_Bool_Exp | null | undefined;
  Secretary1EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Secretary1FirstName?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1LastName?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1MiddleName?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1NameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1NameFull?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1NamePreferredFull?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary1PhoneExtension?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2EmployeeId?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  Secretary2FirstName?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2LastName?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2MiddleName?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2NameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2NameFull?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2NamePreferredDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2NamePreferredFull?: String_Mssql_Comparison_Exp | null | undefined;
  Secretary2PhoneExtension?: String_Mssql_Comparison_Exp | null | undefined;
  SpouseFirstName?: String_Mssql_Comparison_Exp | null | undefined;
  SpouseLastName?: String_Mssql_Comparison_Exp | null | undefined;
  SpouseMiddleInit?: String_Mssql_Comparison_Exp | null | undefined;
  SpouseNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  SpouseNameFull?: String_Mssql_Comparison_Exp | null | undefined;
  StatusActiveEmployeeIndicator?: Int_Mssql_Comparison_Exp | null | undefined;
  StatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  StatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  StatusDescription2?: String_Mssql_Comparison_Exp | null | undefined;
  StatusLabel?: String_Mssql_Comparison_Exp | null | undefined;
  TimeKeeperCostEntryFlag?: String_Mssql_Comparison_Exp | null | undefined;
  TimeKeeperTimeEntryFlag?: String_Mssql_Comparison_Exp | null | undefined;
  TimeReporter?: String_Mssql_Comparison_Exp | null | undefined;
  TimekeeperGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  TimekeeperIndex?: Int_Mssql_Comparison_Exp | null | undefined;
  Title?: String_Mssql_Comparison_Exp | null | undefined;
  TitleDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  TitleFullyQualified?: String_Mssql_Comparison_Exp | null | undefined;
  WallBuilderEntityID?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Personnel_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Personnel_Bool_Exp> | null | undefined;
  dateClerkship?: String_Mssql_Comparison_Exp | null | undefined;
  mlfsl_personnel_bar?: Mlfsl_Personnel_Bar_Bool_Exp | null | undefined;
  mlfsl_personnel_clerkship?: Mlfsl_Personnel_Clerkship_Bool_Exp | null | undefined;
  mlfsl_personnel_committee?: Mlfsl_Personnel_Committee_Bool_Exp | null | undefined;
  mlfsl_personnel_court?: Mlfsl_Personnel_Court_Bool_Exp | null | undefined;
  mlfsl_personnel_language?: Mlfsl_Personnel_Language_Bool_Exp | null | undefined;
  probono_goals?: Mlfsl_Probono_Goal_Bool_Exp | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Aggregate_Order_By = {
  avg?: Mlfsl_Personnel_Clerkship_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Personnel_Clerkship_Max_Order_By | null | undefined;
  min?: Mlfsl_Personnel_Clerkship_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Personnel_Clerkship_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Personnel_Clerkship_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Personnel_Clerkship_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Personnel_Clerkship_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Personnel_Clerkship_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Personnel_Clerkship_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Personnel_Clerkship_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Avg_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelClerkship". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Clerkship_Bool_Exp = {
  ClerkshipCourt?: String_Mssql_Comparison_Exp | null | undefined;
  ClerkshipEndYear?: String_Mssql_Comparison_Exp | null | undefined;
  ClerkshipJudge?: String_Mssql_Comparison_Exp | null | undefined;
  ClerkshipStartYear?: String_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimPersonnelClerkshipKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  ETLModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Personnel_Clerkship_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Personnel_Clerkship_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Personnel_Clerkship_Bool_Exp> | null | undefined;
  mlfsl_personnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Max_Order_By = {
  ClerkshipCourt?: Order_By | null | undefined;
  ClerkshipEndYear?: Order_By | null | undefined;
  ClerkshipJudge?: Order_By | null | undefined;
  ClerkshipStartYear?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  ETLCreatedDate?: Order_By | null | undefined;
  ETLModifiedDate?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Min_Order_By = {
  ClerkshipCourt?: Order_By | null | undefined;
  ClerkshipEndYear?: Order_By | null | undefined;
  ClerkshipJudge?: Order_By | null | undefined;
  ClerkshipStartYear?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  ETLCreatedDate?: Order_By | null | undefined;
  ETLModifiedDate?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Stddev_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Stddev_Pop_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Stddev_Samp_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Sum_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Var_Pop_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Var_Samp_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Variance_Order_By = {
  DimPersonnelClerkshipKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Aggregate_Order_By = {
  avg?: Mlfsl_Personnel_Committee_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Personnel_Committee_Max_Order_By | null | undefined;
  min?: Mlfsl_Personnel_Committee_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Personnel_Committee_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Personnel_Committee_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Personnel_Committee_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Personnel_Committee_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Personnel_Committee_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Personnel_Committee_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Personnel_Committee_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Avg_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelCommittee". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Committee_Bool_Exp = {
  CommitteeFocus?: String_Mssql_Comparison_Exp | null | undefined;
  CommitteeName?: String_Mssql_Comparison_Exp | null | undefined;
  CurrentMembershipIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimPersonnelCommitteeKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  ETLModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  MemberLocationResponsibility?: String_Mssql_Comparison_Exp | null | undefined;
  MemberRole?: String_Mssql_Comparison_Exp | null | undefined;
  MembershipEndDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  MembershipStartDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Personnel_Committee_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Personnel_Committee_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Personnel_Committee_Bool_Exp> | null | undefined;
  mlfsl_personnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Max_Order_By = {
  CommitteeFocus?: Order_By | null | undefined;
  CommitteeName?: Order_By | null | undefined;
  CurrentMembershipIndicator?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  ETLCreatedDate?: Order_By | null | undefined;
  ETLModifiedDate?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  MemberLocationResponsibility?: Order_By | null | undefined;
  MemberRole?: Order_By | null | undefined;
  MembershipEndDate?: Order_By | null | undefined;
  MembershipStartDate?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Min_Order_By = {
  CommitteeFocus?: Order_By | null | undefined;
  CommitteeName?: Order_By | null | undefined;
  CurrentMembershipIndicator?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  ETLCreatedDate?: Order_By | null | undefined;
  ETLModifiedDate?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  MemberLocationResponsibility?: Order_By | null | undefined;
  MemberRole?: Order_By | null | undefined;
  MembershipEndDate?: Order_By | null | undefined;
  MembershipStartDate?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Stddev_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Stddev_Pop_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Stddev_Samp_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Sum_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Var_Pop_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Var_Samp_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Variance_Order_By = {
  DimPersonnelCommitteeKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Aggregate_Order_By = {
  avg?: Mlfsl_Personnel_Court_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Personnel_Court_Max_Order_By | null | undefined;
  min?: Mlfsl_Personnel_Court_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Personnel_Court_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Personnel_Court_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Personnel_Court_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Personnel_Court_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Personnel_Court_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Personnel_Court_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Personnel_Court_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Avg_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelCourt". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Court_Bool_Exp = {
  Court?: String_Mssql_Comparison_Exp | null | undefined;
  CourtYear?: String_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimPersonnelCourtKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Personnel_Court_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Personnel_Court_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Personnel_Court_Bool_Exp> | null | undefined;
  mlfsl_personnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Max_Order_By = {
  Court?: Order_By | null | undefined;
  CourtYear?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Min_Order_By = {
  Court?: Order_By | null | undefined;
  CourtYear?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Stddev_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Stddev_Pop_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Stddev_Samp_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Sum_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Var_Pop_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Var_Samp_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Variance_Order_By = {
  DimPersonnelCourtKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLChecksum?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
};

/** order by aggregate values of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Aggregate_Order_By = {
  avg?: Mlfsl_Personnel_Language_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Personnel_Language_Max_Order_By | null | undefined;
  min?: Mlfsl_Personnel_Language_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Personnel_Language_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Personnel_Language_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Personnel_Language_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Personnel_Language_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Personnel_Language_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Personnel_Language_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Personnel_Language_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Avg_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelLanguage". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Language_Bool_Exp = {
  DimPersonnelLanguageKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  EmployeeIdOriginal?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  IsDeletedIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  Language?: String_Mssql_Comparison_Exp | null | undefined;
  LawsonCreationDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  MnetDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  ReadingProficiency?: String_Mssql_Comparison_Exp | null | undefined;
  SpeakingProficiency?: String_Mssql_Comparison_Exp | null | undefined;
  WritingProficiency?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Personnel_Language_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Personnel_Language_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Personnel_Language_Bool_Exp> | null | undefined;
  mlfsl_personnel?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Max_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IsDeletedIndicator?: Order_By | null | undefined;
  Language?: Order_By | null | undefined;
  LawsonCreationDate?: Order_By | null | undefined;
  MnetDisplay?: Order_By | null | undefined;
  ReadingProficiency?: Order_By | null | undefined;
  SpeakingProficiency?: Order_By | null | undefined;
  WritingProficiency?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Min_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IsDeletedIndicator?: Order_By | null | undefined;
  Language?: Order_By | null | undefined;
  LawsonCreationDate?: Order_By | null | undefined;
  MnetDisplay?: Order_By | null | undefined;
  ReadingProficiency?: Order_By | null | undefined;
  SpeakingProficiency?: Order_By | null | undefined;
  WritingProficiency?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Stddev_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Stddev_Pop_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Stddev_Samp_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Sum_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Var_Pop_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Var_Samp_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Variance_Order_By = {
  DimPersonnelLanguageKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
};

/** order by max() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Max_Order_By = {
  ActiveDirectoryBusinessCategory?: Order_By | null | undefined;
  ActiveDirectoryDisabledIndicator?: Order_By | null | undefined;
  ActiveDirectoryDistinguishedName?: Order_By | null | undefined;
  ActiveDirectoryEmail?: Order_By | null | undefined;
  ActiveDirectoryHomeDirectory?: Order_By | null | undefined;
  ActiveDirectoryLogin?: Order_By | null | undefined;
  ActiveDirectoryMailboxIndicator?: Order_By | null | undefined;
  ActiveDirectorySEVDepartedIndicator?: Order_By | null | undefined;
  BYODIndicator?: Order_By | null | undefined;
  BarAdmissionFirst?: Order_By | null | undefined;
  BardateFirst?: Order_By | null | undefined;
  BillingCoordinatorEmployeeId?: Order_By | null | undefined;
  BlackberryPin?: Order_By | null | undefined;
  BusinessPostalOfficeAddress1?: Order_By | null | undefined;
  BusinessPostalOfficeAddress2?: Order_By | null | undefined;
  BusinessPostalOfficeAddress3?: Order_By | null | undefined;
  BusinessPostalOfficeCity?: Order_By | null | undefined;
  BusinessPostalOfficeCode?: Order_By | null | undefined;
  BusinessPostalOfficeCountryCode?: Order_By | null | undefined;
  BusinessPostalOfficeState?: Order_By | null | undefined;
  BusinessPostalOfficeZip?: Order_By | null | undefined;
  BusinessPrimaryOffice?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress1?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress2?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress3?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress4?: Order_By | null | undefined;
  BusinessPrimaryOfficeCity?: Order_By | null | undefined;
  BusinessPrimaryOfficeCode?: Order_By | null | undefined;
  BusinessPrimaryOfficeCodeNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficeCodeNumberWithExtension?: Order_By | null | undefined;
  BusinessPrimaryOfficeCountryCode?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailBoxNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailGroup?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailGroupCode?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneCountry?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneExtension?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneNumberFull?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: Order_By | null | undefined;
  BusinessPrimaryOfficeState?: Order_By | null | undefined;
  BusinessPrimaryOfficeZip?: Order_By | null | undefined;
  BusinessSecondaryOffice?: Order_By | null | undefined;
  BusinessSecondaryOfficeCode?: Order_By | null | undefined;
  BusinessSecondaryOfficeCodeNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficeCodeNumberWithExtension?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneCountry?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneExtension?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneNumberFull?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: Order_By | null | undefined;
  CellPhoneCountry?: Order_By | null | undefined;
  CellPhoneNumber?: Order_By | null | undefined;
  CellPhoneNumberFull?: Order_By | null | undefined;
  DataCenterRegion?: Order_By | null | undefined;
  DataSource?: Order_By | null | undefined;
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  ElitePracticeArea?: Order_By | null | undefined;
  ElitePracticeAreaDelimited?: Order_By | null | undefined;
  EliteStatus?: Order_By | null | undefined;
  EliteSubSubPracticeGroup?: Order_By | null | undefined;
  EliteTimekeepLocation?: Order_By | null | undefined;
  EliteTitle?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  EliteWorkLocation?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  Email?: Order_By | null | undefined;
  EmailSignatureCaveatText?: Order_By | null | undefined;
  EmergencyContact1FirstName?: Order_By | null | undefined;
  EmergencyContact1HomePhoneCountry?: Order_By | null | undefined;
  EmergencyContact1HomePhoneFull?: Order_By | null | undefined;
  EmergencyContact1HomePhoneNumber?: Order_By | null | undefined;
  EmergencyContact1LastName?: Order_By | null | undefined;
  EmergencyContact1MiddleName?: Order_By | null | undefined;
  EmergencyContact1NameDisplay?: Order_By | null | undefined;
  EmergencyContact1NameFull?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneCountry?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneExtension?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneFull?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneNumber?: Order_By | null | undefined;
  EmergencyContact2FirstName?: Order_By | null | undefined;
  EmergencyContact2HomePhoneCountry?: Order_By | null | undefined;
  EmergencyContact2HomePhoneFull?: Order_By | null | undefined;
  EmergencyContact2HomePhoneNumber?: Order_By | null | undefined;
  EmergencyContact2LastName?: Order_By | null | undefined;
  EmergencyContact2MiddleName?: Order_By | null | undefined;
  EmergencyContact2NameDisplay?: Order_By | null | undefined;
  EmergencyContact2NameFull?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneCountry?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneExtension?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneFull?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneNumber?: Order_By | null | undefined;
  EmployeeCategoryCode?: Order_By | null | undefined;
  EmployeeCategoryDescription?: Order_By | null | undefined;
  EmployeeId?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EmployeeTypeFlag?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreateddate?: Order_By | null | undefined;
  EtlModifieddate?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  Gender?: Order_By | null | undefined;
  GenderDescription?: Order_By | null | undefined;
  GradClassYear?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  IsBilledByAIC?: Order_By | null | undefined;
  IsDMSDenyAccess?: Order_By | null | undefined;
  IsExemptIndicator?: Order_By | null | undefined;
  IsHRCellPhoneUnlistedIndicator?: Order_By | null | undefined;
  IsHREducationYearUnlistedIndicator?: Order_By | null | undefined;
  IsHRHomeAddressUnlistedIndicator?: Order_By | null | undefined;
  IsHRHomePhoneUnlistedIndicator?: Order_By | null | undefined;
  IsHRSpouseUnlistedIndicator?: Order_By | null | undefined;
  IsHrDefinedAttorneyIndicator?: Order_By | null | undefined;
  IsHrUnlistedIndicator?: Order_By | null | undefined;
  IsLateralAttorney?: Order_By | null | undefined;
  IsLegalProfessionalIndicator?: Order_By | null | undefined;
  JobCode?: Order_By | null | undefined;
  JobFamily?: Order_By | null | undefined;
  JobFamilyGroup?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsonSecondarySubSubPracticeGroup?: Order_By | null | undefined;
  LawsonSubSubPracticeGroup?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  MLBClassYear?: Order_By | null | undefined;
  Manager1EmployeeId?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeId?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeId?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeId?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeId?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeId?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MarsSubSubPracticeGroup?: Order_By | null | undefined;
  MarsTitle?: Order_By | null | undefined;
  MarsWorkLocation?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  NameDisplay?: Order_By | null | undefined;
  NameFirst?: Order_By | null | undefined;
  NameFirstBilling?: Order_By | null | undefined;
  NameFull?: Order_By | null | undefined;
  NameInitialsElite?: Order_By | null | undefined;
  NameLast?: Order_By | null | undefined;
  NameLastBilling?: Order_By | null | undefined;
  NameLastNoSuffix?: Order_By | null | undefined;
  NameMaidenFirst?: Order_By | null | undefined;
  NameMaidenLast?: Order_By | null | undefined;
  NameMaidenMiddleInitial?: Order_By | null | undefined;
  NameMiddle?: Order_By | null | undefined;
  NameMiddleInitial?: Order_By | null | undefined;
  NameNick?: Order_By | null | undefined;
  NameNickIa?: Order_By | null | undefined;
  NamePreferredDisplay?: Order_By | null | undefined;
  NamePreferredDisplay_?: Order_By | null | undefined;
  NamePreferredFirst?: Order_By | null | undefined;
  NamePreferredFull?: Order_By | null | undefined;
  NamePreferredLast?: Order_By | null | undefined;
  NamePreferredMiddle?: Order_By | null | undefined;
  NameSuffix?: Order_By | null | undefined;
  NameTDDisplay?: Order_By | null | undefined;
  NonFirmOfficeTaxJurisdictionResident?: Order_By | null | undefined;
  NonPhiladelphiaResident?: Order_By | null | undefined;
  ParalegalTier?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  PayrollBatchId?: Order_By | null | undefined;
  PayrollFileNumber?: Order_By | null | undefined;
  PayrollPayGroup?: Order_By | null | undefined;
  PersonalAddressFour?: Order_By | null | undefined;
  PersonalAddressOne?: Order_By | null | undefined;
  PersonalAddressThree?: Order_By | null | undefined;
  PersonalAddressTwo?: Order_By | null | undefined;
  PersonalCity?: Order_By | null | undefined;
  PersonalCountry?: Order_By | null | undefined;
  PersonalEmailAddress?: Order_By | null | undefined;
  PersonalMatter?: Order_By | null | undefined;
  PersonalPhoneCountry?: Order_By | null | undefined;
  PersonalPhoneNumber?: Order_By | null | undefined;
  PersonalPhoneNumberFull?: Order_By | null | undefined;
  PersonalPronouns?: Order_By | null | undefined;
  PersonalSecondPhoneCountry?: Order_By | null | undefined;
  PersonalSecondPhoneNumber?: Order_By | null | undefined;
  PersonalSecondPhoneNumberFull?: Order_By | null | undefined;
  PersonalState?: Order_By | null | undefined;
  PersonalZip?: Order_By | null | undefined;
  PersonnelSourceAbbreviation?: Order_By | null | undefined;
  PersonnelSourceName?: Order_By | null | undefined;
  PersonnelSourceNumber?: Order_By | null | undefined;
  PictureURL?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  RehireIndicator?: Order_By | null | undefined;
  RemoteWorkingProgramIndicator?: Order_By | null | undefined;
  RequiredTime?: Order_By | null | undefined;
  Secretary1EmployeeId?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary1FirstName?: Order_By | null | undefined;
  Secretary1LastName?: Order_By | null | undefined;
  Secretary1MiddleName?: Order_By | null | undefined;
  Secretary1NameDisplay?: Order_By | null | undefined;
  Secretary1NameFull?: Order_By | null | undefined;
  Secretary1NamePreferredDisplay?: Order_By | null | undefined;
  Secretary1NamePreferredFull?: Order_By | null | undefined;
  Secretary1PhoneExtension?: Order_By | null | undefined;
  Secretary2EmployeeId?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2FirstName?: Order_By | null | undefined;
  Secretary2LastName?: Order_By | null | undefined;
  Secretary2MiddleName?: Order_By | null | undefined;
  Secretary2NameDisplay?: Order_By | null | undefined;
  Secretary2NameFull?: Order_By | null | undefined;
  Secretary2NamePreferredDisplay?: Order_By | null | undefined;
  Secretary2NamePreferredFull?: Order_By | null | undefined;
  Secretary2PhoneExtension?: Order_By | null | undefined;
  SpouseFirstName?: Order_By | null | undefined;
  SpouseLastName?: Order_By | null | undefined;
  SpouseMiddleInit?: Order_By | null | undefined;
  SpouseNameDisplay?: Order_By | null | undefined;
  SpouseNameFull?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  StatusCode?: Order_By | null | undefined;
  StatusDescription?: Order_By | null | undefined;
  StatusDescription2?: Order_By | null | undefined;
  StatusLabel?: Order_By | null | undefined;
  TimeKeeperCostEntryFlag?: Order_By | null | undefined;
  TimeKeeperTimeEntryFlag?: Order_By | null | undefined;
  TimeReporter?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  Title?: Order_By | null | undefined;
  TitleDisplay?: Order_By | null | undefined;
  TitleFullyQualified?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
  dateClerkship?: Order_By | null | undefined;
};

/** order by min() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Min_Order_By = {
  ActiveDirectoryBusinessCategory?: Order_By | null | undefined;
  ActiveDirectoryDisabledIndicator?: Order_By | null | undefined;
  ActiveDirectoryDistinguishedName?: Order_By | null | undefined;
  ActiveDirectoryEmail?: Order_By | null | undefined;
  ActiveDirectoryHomeDirectory?: Order_By | null | undefined;
  ActiveDirectoryLogin?: Order_By | null | undefined;
  ActiveDirectoryMailboxIndicator?: Order_By | null | undefined;
  ActiveDirectorySEVDepartedIndicator?: Order_By | null | undefined;
  BYODIndicator?: Order_By | null | undefined;
  BarAdmissionFirst?: Order_By | null | undefined;
  BardateFirst?: Order_By | null | undefined;
  BillingCoordinatorEmployeeId?: Order_By | null | undefined;
  BlackberryPin?: Order_By | null | undefined;
  BusinessPostalOfficeAddress1?: Order_By | null | undefined;
  BusinessPostalOfficeAddress2?: Order_By | null | undefined;
  BusinessPostalOfficeAddress3?: Order_By | null | undefined;
  BusinessPostalOfficeCity?: Order_By | null | undefined;
  BusinessPostalOfficeCode?: Order_By | null | undefined;
  BusinessPostalOfficeCountryCode?: Order_By | null | undefined;
  BusinessPostalOfficeState?: Order_By | null | undefined;
  BusinessPostalOfficeZip?: Order_By | null | undefined;
  BusinessPrimaryOffice?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress1?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress2?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress3?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress4?: Order_By | null | undefined;
  BusinessPrimaryOfficeCity?: Order_By | null | undefined;
  BusinessPrimaryOfficeCode?: Order_By | null | undefined;
  BusinessPrimaryOfficeCodeNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficeCodeNumberWithExtension?: Order_By | null | undefined;
  BusinessPrimaryOfficeCountryCode?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailBoxNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailGroup?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailGroupCode?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneCountry?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneExtension?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneNumberFull?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: Order_By | null | undefined;
  BusinessPrimaryOfficeState?: Order_By | null | undefined;
  BusinessPrimaryOfficeZip?: Order_By | null | undefined;
  BusinessSecondaryOffice?: Order_By | null | undefined;
  BusinessSecondaryOfficeCode?: Order_By | null | undefined;
  BusinessSecondaryOfficeCodeNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficeCodeNumberWithExtension?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneCountry?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneExtension?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneNumberFull?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: Order_By | null | undefined;
  CellPhoneCountry?: Order_By | null | undefined;
  CellPhoneNumber?: Order_By | null | undefined;
  CellPhoneNumberFull?: Order_By | null | undefined;
  DataCenterRegion?: Order_By | null | undefined;
  DataSource?: Order_By | null | undefined;
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  ElitePracticeArea?: Order_By | null | undefined;
  ElitePracticeAreaDelimited?: Order_By | null | undefined;
  EliteStatus?: Order_By | null | undefined;
  EliteSubSubPracticeGroup?: Order_By | null | undefined;
  EliteTimekeepLocation?: Order_By | null | undefined;
  EliteTitle?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  EliteWorkLocation?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  Email?: Order_By | null | undefined;
  EmailSignatureCaveatText?: Order_By | null | undefined;
  EmergencyContact1FirstName?: Order_By | null | undefined;
  EmergencyContact1HomePhoneCountry?: Order_By | null | undefined;
  EmergencyContact1HomePhoneFull?: Order_By | null | undefined;
  EmergencyContact1HomePhoneNumber?: Order_By | null | undefined;
  EmergencyContact1LastName?: Order_By | null | undefined;
  EmergencyContact1MiddleName?: Order_By | null | undefined;
  EmergencyContact1NameDisplay?: Order_By | null | undefined;
  EmergencyContact1NameFull?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneCountry?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneExtension?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneFull?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneNumber?: Order_By | null | undefined;
  EmergencyContact2FirstName?: Order_By | null | undefined;
  EmergencyContact2HomePhoneCountry?: Order_By | null | undefined;
  EmergencyContact2HomePhoneFull?: Order_By | null | undefined;
  EmergencyContact2HomePhoneNumber?: Order_By | null | undefined;
  EmergencyContact2LastName?: Order_By | null | undefined;
  EmergencyContact2MiddleName?: Order_By | null | undefined;
  EmergencyContact2NameDisplay?: Order_By | null | undefined;
  EmergencyContact2NameFull?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneCountry?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneExtension?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneFull?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneNumber?: Order_By | null | undefined;
  EmployeeCategoryCode?: Order_By | null | undefined;
  EmployeeCategoryDescription?: Order_By | null | undefined;
  EmployeeId?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EmployeeTypeFlag?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreateddate?: Order_By | null | undefined;
  EtlModifieddate?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  Gender?: Order_By | null | undefined;
  GenderDescription?: Order_By | null | undefined;
  GradClassYear?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  IsBilledByAIC?: Order_By | null | undefined;
  IsDMSDenyAccess?: Order_By | null | undefined;
  IsExemptIndicator?: Order_By | null | undefined;
  IsHRCellPhoneUnlistedIndicator?: Order_By | null | undefined;
  IsHREducationYearUnlistedIndicator?: Order_By | null | undefined;
  IsHRHomeAddressUnlistedIndicator?: Order_By | null | undefined;
  IsHRHomePhoneUnlistedIndicator?: Order_By | null | undefined;
  IsHRSpouseUnlistedIndicator?: Order_By | null | undefined;
  IsHrDefinedAttorneyIndicator?: Order_By | null | undefined;
  IsHrUnlistedIndicator?: Order_By | null | undefined;
  IsLateralAttorney?: Order_By | null | undefined;
  IsLegalProfessionalIndicator?: Order_By | null | undefined;
  JobCode?: Order_By | null | undefined;
  JobFamily?: Order_By | null | undefined;
  JobFamilyGroup?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsonSecondarySubSubPracticeGroup?: Order_By | null | undefined;
  LawsonSubSubPracticeGroup?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  MLBClassYear?: Order_By | null | undefined;
  Manager1EmployeeId?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeId?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeId?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeId?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeId?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeId?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MarsSubSubPracticeGroup?: Order_By | null | undefined;
  MarsTitle?: Order_By | null | undefined;
  MarsWorkLocation?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  NameDisplay?: Order_By | null | undefined;
  NameFirst?: Order_By | null | undefined;
  NameFirstBilling?: Order_By | null | undefined;
  NameFull?: Order_By | null | undefined;
  NameInitialsElite?: Order_By | null | undefined;
  NameLast?: Order_By | null | undefined;
  NameLastBilling?: Order_By | null | undefined;
  NameLastNoSuffix?: Order_By | null | undefined;
  NameMaidenFirst?: Order_By | null | undefined;
  NameMaidenLast?: Order_By | null | undefined;
  NameMaidenMiddleInitial?: Order_By | null | undefined;
  NameMiddle?: Order_By | null | undefined;
  NameMiddleInitial?: Order_By | null | undefined;
  NameNick?: Order_By | null | undefined;
  NameNickIa?: Order_By | null | undefined;
  NamePreferredDisplay?: Order_By | null | undefined;
  NamePreferredDisplay_?: Order_By | null | undefined;
  NamePreferredFirst?: Order_By | null | undefined;
  NamePreferredFull?: Order_By | null | undefined;
  NamePreferredLast?: Order_By | null | undefined;
  NamePreferredMiddle?: Order_By | null | undefined;
  NameSuffix?: Order_By | null | undefined;
  NameTDDisplay?: Order_By | null | undefined;
  NonFirmOfficeTaxJurisdictionResident?: Order_By | null | undefined;
  NonPhiladelphiaResident?: Order_By | null | undefined;
  ParalegalTier?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  PayrollBatchId?: Order_By | null | undefined;
  PayrollFileNumber?: Order_By | null | undefined;
  PayrollPayGroup?: Order_By | null | undefined;
  PersonalAddressFour?: Order_By | null | undefined;
  PersonalAddressOne?: Order_By | null | undefined;
  PersonalAddressThree?: Order_By | null | undefined;
  PersonalAddressTwo?: Order_By | null | undefined;
  PersonalCity?: Order_By | null | undefined;
  PersonalCountry?: Order_By | null | undefined;
  PersonalEmailAddress?: Order_By | null | undefined;
  PersonalMatter?: Order_By | null | undefined;
  PersonalPhoneCountry?: Order_By | null | undefined;
  PersonalPhoneNumber?: Order_By | null | undefined;
  PersonalPhoneNumberFull?: Order_By | null | undefined;
  PersonalPronouns?: Order_By | null | undefined;
  PersonalSecondPhoneCountry?: Order_By | null | undefined;
  PersonalSecondPhoneNumber?: Order_By | null | undefined;
  PersonalSecondPhoneNumberFull?: Order_By | null | undefined;
  PersonalState?: Order_By | null | undefined;
  PersonalZip?: Order_By | null | undefined;
  PersonnelSourceAbbreviation?: Order_By | null | undefined;
  PersonnelSourceName?: Order_By | null | undefined;
  PersonnelSourceNumber?: Order_By | null | undefined;
  PictureURL?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  RehireIndicator?: Order_By | null | undefined;
  RemoteWorkingProgramIndicator?: Order_By | null | undefined;
  RequiredTime?: Order_By | null | undefined;
  Secretary1EmployeeId?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary1FirstName?: Order_By | null | undefined;
  Secretary1LastName?: Order_By | null | undefined;
  Secretary1MiddleName?: Order_By | null | undefined;
  Secretary1NameDisplay?: Order_By | null | undefined;
  Secretary1NameFull?: Order_By | null | undefined;
  Secretary1NamePreferredDisplay?: Order_By | null | undefined;
  Secretary1NamePreferredFull?: Order_By | null | undefined;
  Secretary1PhoneExtension?: Order_By | null | undefined;
  Secretary2EmployeeId?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2FirstName?: Order_By | null | undefined;
  Secretary2LastName?: Order_By | null | undefined;
  Secretary2MiddleName?: Order_By | null | undefined;
  Secretary2NameDisplay?: Order_By | null | undefined;
  Secretary2NameFull?: Order_By | null | undefined;
  Secretary2NamePreferredDisplay?: Order_By | null | undefined;
  Secretary2NamePreferredFull?: Order_By | null | undefined;
  Secretary2PhoneExtension?: Order_By | null | undefined;
  SpouseFirstName?: Order_By | null | undefined;
  SpouseLastName?: Order_By | null | undefined;
  SpouseMiddleInit?: Order_By | null | undefined;
  SpouseNameDisplay?: Order_By | null | undefined;
  SpouseNameFull?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  StatusCode?: Order_By | null | undefined;
  StatusDescription?: Order_By | null | undefined;
  StatusDescription2?: Order_By | null | undefined;
  StatusLabel?: Order_By | null | undefined;
  TimeKeeperCostEntryFlag?: Order_By | null | undefined;
  TimeKeeperTimeEntryFlag?: Order_By | null | undefined;
  TimeReporter?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  Title?: Order_By | null | undefined;
  TitleDisplay?: Order_By | null | undefined;
  TitleFullyQualified?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
  dateClerkship?: Order_By | null | undefined;
};

/** Ordering options when selecting data from "repl.DimPersonnelNow". */
export type Mlfsl_Personnel_Order_By = {
  ActiveDirectoryBusinessCategory?: Order_By | null | undefined;
  ActiveDirectoryDisabledIndicator?: Order_By | null | undefined;
  ActiveDirectoryDistinguishedName?: Order_By | null | undefined;
  ActiveDirectoryEmail?: Order_By | null | undefined;
  ActiveDirectoryHomeDirectory?: Order_By | null | undefined;
  ActiveDirectoryLogin?: Order_By | null | undefined;
  ActiveDirectoryMailboxIndicator?: Order_By | null | undefined;
  ActiveDirectorySEVDepartedIndicator?: Order_By | null | undefined;
  BYODIndicator?: Order_By | null | undefined;
  BarAdmissionFirst?: Order_By | null | undefined;
  BardateFirst?: Order_By | null | undefined;
  BillingCoordinatorEmployeeId?: Order_By | null | undefined;
  BlackberryPin?: Order_By | null | undefined;
  BusinessPostalOfficeAddress1?: Order_By | null | undefined;
  BusinessPostalOfficeAddress2?: Order_By | null | undefined;
  BusinessPostalOfficeAddress3?: Order_By | null | undefined;
  BusinessPostalOfficeCity?: Order_By | null | undefined;
  BusinessPostalOfficeCode?: Order_By | null | undefined;
  BusinessPostalOfficeCountryCode?: Order_By | null | undefined;
  BusinessPostalOfficeState?: Order_By | null | undefined;
  BusinessPostalOfficeZip?: Order_By | null | undefined;
  BusinessPrimaryOffice?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress1?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress2?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress3?: Order_By | null | undefined;
  BusinessPrimaryOfficeAddress4?: Order_By | null | undefined;
  BusinessPrimaryOfficeCity?: Order_By | null | undefined;
  BusinessPrimaryOfficeCode?: Order_By | null | undefined;
  BusinessPrimaryOfficeCodeNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficeCodeNumberWithExtension?: Order_By | null | undefined;
  BusinessPrimaryOfficeCountryCode?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailBoxNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailGroup?: Order_By | null | undefined;
  BusinessPrimaryOfficeMailGroupCode?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneCountry?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneExtension?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneNumberFull?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: Order_By | null | undefined;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: Order_By | null | undefined;
  BusinessPrimaryOfficeState?: Order_By | null | undefined;
  BusinessPrimaryOfficeZip?: Order_By | null | undefined;
  BusinessSecondaryOffice?: Order_By | null | undefined;
  BusinessSecondaryOfficeCode?: Order_By | null | undefined;
  BusinessSecondaryOfficeCodeNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficeCodeNumberWithExtension?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneCountry?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneExtension?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneNumberFull?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: Order_By | null | undefined;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: Order_By | null | undefined;
  CellPhoneCountry?: Order_By | null | undefined;
  CellPhoneNumber?: Order_By | null | undefined;
  CellPhoneNumberFull?: Order_By | null | undefined;
  DataCenterRegion?: Order_By | null | undefined;
  DataSource?: Order_By | null | undefined;
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHire?: Mlfsl_Date_Order_By | null | undefined;
  DateHireAdjusted?: Mlfsl_Date_Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTerm?: Mlfsl_Date_Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: Order_By | null | undefined;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  ElitePracticeArea?: Order_By | null | undefined;
  ElitePracticeAreaDelimited?: Order_By | null | undefined;
  EliteStatus?: Order_By | null | undefined;
  EliteSubSubPracticeGroup?: Order_By | null | undefined;
  EliteTimekeepLocation?: Order_By | null | undefined;
  EliteTitle?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  EliteWorkLocation?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  Email?: Order_By | null | undefined;
  EmailSignatureCaveatText?: Order_By | null | undefined;
  EmergencyContact1FirstName?: Order_By | null | undefined;
  EmergencyContact1HomePhoneCountry?: Order_By | null | undefined;
  EmergencyContact1HomePhoneFull?: Order_By | null | undefined;
  EmergencyContact1HomePhoneNumber?: Order_By | null | undefined;
  EmergencyContact1LastName?: Order_By | null | undefined;
  EmergencyContact1MiddleName?: Order_By | null | undefined;
  EmergencyContact1NameDisplay?: Order_By | null | undefined;
  EmergencyContact1NameFull?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneCountry?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneExtension?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneFull?: Order_By | null | undefined;
  EmergencyContact1WorkPhoneNumber?: Order_By | null | undefined;
  EmergencyContact2FirstName?: Order_By | null | undefined;
  EmergencyContact2HomePhoneCountry?: Order_By | null | undefined;
  EmergencyContact2HomePhoneFull?: Order_By | null | undefined;
  EmergencyContact2HomePhoneNumber?: Order_By | null | undefined;
  EmergencyContact2LastName?: Order_By | null | undefined;
  EmergencyContact2MiddleName?: Order_By | null | undefined;
  EmergencyContact2NameDisplay?: Order_By | null | undefined;
  EmergencyContact2NameFull?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneCountry?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneExtension?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneFull?: Order_By | null | undefined;
  EmergencyContact2WorkPhoneNumber?: Order_By | null | undefined;
  EmployeeCategoryCode?: Order_By | null | undefined;
  EmployeeCategoryDescription?: Order_By | null | undefined;
  EmployeeId?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EmployeeTypeFlag?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreateddate?: Order_By | null | undefined;
  EtlModifieddate?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  Gender?: Order_By | null | undefined;
  GenderDescription?: Order_By | null | undefined;
  GradClassYear?: Order_By | null | undefined;
  GroupJoins_aggregate?: Mlfsl_Ad_Join_Aggregate_Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  IsBilledByAIC?: Order_By | null | undefined;
  IsDMSDenyAccess?: Order_By | null | undefined;
  IsExemptIndicator?: Order_By | null | undefined;
  IsHRCellPhoneUnlistedIndicator?: Order_By | null | undefined;
  IsHREducationYearUnlistedIndicator?: Order_By | null | undefined;
  IsHRHomeAddressUnlistedIndicator?: Order_By | null | undefined;
  IsHRHomePhoneUnlistedIndicator?: Order_By | null | undefined;
  IsHRSpouseUnlistedIndicator?: Order_By | null | undefined;
  IsHrDefinedAttorneyIndicator?: Order_By | null | undefined;
  IsHrUnlistedIndicator?: Order_By | null | undefined;
  IsLateralAttorney?: Order_By | null | undefined;
  IsLegalProfessionalIndicator?: Order_By | null | undefined;
  JobCode?: Order_By | null | undefined;
  JobFamily?: Order_By | null | undefined;
  JobFamilyGroup?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsonSecondarySubSubPracticeGroup?: Order_By | null | undefined;
  LawsonSubSubPracticeGroup?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Login?: Mlfsl_Ad_Login_Order_By | null | undefined;
  MLBClassYear?: Order_By | null | undefined;
  Manager1EmployeeId?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeId?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeId?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeId?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeId?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeId?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MarsSubSubPracticeGroup?: Order_By | null | undefined;
  MarsTitle?: Order_By | null | undefined;
  MarsWorkLocation?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  NameDisplay?: Order_By | null | undefined;
  NameFirst?: Order_By | null | undefined;
  NameFirstBilling?: Order_By | null | undefined;
  NameFull?: Order_By | null | undefined;
  NameInitialsElite?: Order_By | null | undefined;
  NameLast?: Order_By | null | undefined;
  NameLastBilling?: Order_By | null | undefined;
  NameLastNoSuffix?: Order_By | null | undefined;
  NameMaidenFirst?: Order_By | null | undefined;
  NameMaidenLast?: Order_By | null | undefined;
  NameMaidenMiddleInitial?: Order_By | null | undefined;
  NameMiddle?: Order_By | null | undefined;
  NameMiddleInitial?: Order_By | null | undefined;
  NameNick?: Order_By | null | undefined;
  NameNickIa?: Order_By | null | undefined;
  NamePreferredDisplay?: Order_By | null | undefined;
  NamePreferredDisplay_?: Order_By | null | undefined;
  NamePreferredFirst?: Order_By | null | undefined;
  NamePreferredFull?: Order_By | null | undefined;
  NamePreferredLast?: Order_By | null | undefined;
  NamePreferredMiddle?: Order_By | null | undefined;
  NameSuffix?: Order_By | null | undefined;
  NameTDDisplay?: Order_By | null | undefined;
  NonFirmOfficeTaxJurisdictionResident?: Order_By | null | undefined;
  NonPhiladelphiaResident?: Order_By | null | undefined;
  ParalegalTier?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  PayrollBatchId?: Order_By | null | undefined;
  PayrollFileNumber?: Order_By | null | undefined;
  PayrollPayGroup?: Order_By | null | undefined;
  PersonEducation_aggregate?: Mlfsl_Person_Education_Aggregate_Order_By | null | undefined;
  PersonalAddressFour?: Order_By | null | undefined;
  PersonalAddressOne?: Order_By | null | undefined;
  PersonalAddressThree?: Order_By | null | undefined;
  PersonalAddressTwo?: Order_By | null | undefined;
  PersonalCity?: Order_By | null | undefined;
  PersonalCountry?: Order_By | null | undefined;
  PersonalEmailAddress?: Order_By | null | undefined;
  PersonalMatter?: Order_By | null | undefined;
  PersonalPhoneCountry?: Order_By | null | undefined;
  PersonalPhoneNumber?: Order_By | null | undefined;
  PersonalPhoneNumberFull?: Order_By | null | undefined;
  PersonalPronouns?: Order_By | null | undefined;
  PersonalSecondPhoneCountry?: Order_By | null | undefined;
  PersonalSecondPhoneNumber?: Order_By | null | undefined;
  PersonalSecondPhoneNumberFull?: Order_By | null | undefined;
  PersonalState?: Order_By | null | undefined;
  PersonalZip?: Order_By | null | undefined;
  PersonnelSourceAbbreviation?: Order_By | null | undefined;
  PersonnelSourceName?: Order_By | null | undefined;
  PersonnelSourceNumber?: Order_By | null | undefined;
  PictureURL?: Order_By | null | undefined;
  PrimaryAssistant?: Mlfsl_Personnel_Order_By | null | undefined;
  PrimaryOffice?: Mlfsl_Office_Order_By | null | undefined;
  PrimaryPracticeGroup?: Mlfsl_Practicegroup_Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  RehireIndicator?: Order_By | null | undefined;
  RemoteWorkingProgramIndicator?: Order_By | null | undefined;
  RequiredTime?: Order_By | null | undefined;
  SecondaryAssistant?: Mlfsl_Personnel_Order_By | null | undefined;
  SecondaryOffice?: Mlfsl_Office_Order_By | null | undefined;
  SecondaryPracticeGroup?: Mlfsl_Practicegroup_Order_By | null | undefined;
  Secretary1EmployeeId?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary1FirstName?: Order_By | null | undefined;
  Secretary1LastName?: Order_By | null | undefined;
  Secretary1MiddleName?: Order_By | null | undefined;
  Secretary1NameDisplay?: Order_By | null | undefined;
  Secretary1NameFull?: Order_By | null | undefined;
  Secretary1NamePreferredDisplay?: Order_By | null | undefined;
  Secretary1NamePreferredFull?: Order_By | null | undefined;
  Secretary1PhoneExtension?: Order_By | null | undefined;
  Secretary2EmployeeId?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2FirstName?: Order_By | null | undefined;
  Secretary2LastName?: Order_By | null | undefined;
  Secretary2MiddleName?: Order_By | null | undefined;
  Secretary2NameDisplay?: Order_By | null | undefined;
  Secretary2NameFull?: Order_By | null | undefined;
  Secretary2NamePreferredDisplay?: Order_By | null | undefined;
  Secretary2NamePreferredFull?: Order_By | null | undefined;
  Secretary2PhoneExtension?: Order_By | null | undefined;
  SpouseFirstName?: Order_By | null | undefined;
  SpouseLastName?: Order_By | null | undefined;
  SpouseMiddleInit?: Order_By | null | undefined;
  SpouseNameDisplay?: Order_By | null | undefined;
  SpouseNameFull?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  StatusCode?: Order_By | null | undefined;
  StatusDescription?: Order_By | null | undefined;
  StatusDescription2?: Order_By | null | undefined;
  StatusLabel?: Order_By | null | undefined;
  TimeKeeperCostEntryFlag?: Order_By | null | undefined;
  TimeKeeperTimeEntryFlag?: Order_By | null | undefined;
  TimeReporter?: Order_By | null | undefined;
  TimekeeperGUID?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  Title?: Order_By | null | undefined;
  TitleDisplay?: Order_By | null | undefined;
  TitleFullyQualified?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
  dateClerkship?: Order_By | null | undefined;
  mlfsl_personnel_bar_aggregate?: Mlfsl_Personnel_Bar_Aggregate_Order_By | null | undefined;
  mlfsl_personnel_clerkship_aggregate?: Mlfsl_Personnel_Clerkship_Aggregate_Order_By | null | undefined;
  mlfsl_personnel_committee_aggregate?: Mlfsl_Personnel_Committee_Aggregate_Order_By | null | undefined;
  mlfsl_personnel_court_aggregate?: Mlfsl_Personnel_Court_Aggregate_Order_By | null | undefined;
  mlfsl_personnel_language_aggregate?: Mlfsl_Personnel_Language_Aggregate_Order_By | null | undefined;
  probono_goals_aggregate?: Mlfsl_Probono_Goal_Aggregate_Order_By | null | undefined;
};

/** order by stddev() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Stddev_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Stddev_Pop_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Stddev_Samp_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by sum() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Sum_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Var_Pop_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Var_Samp_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** order by variance() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Variance_Order_By = {
  DateAccessRemoveKey?: Order_By | null | undefined;
  DateAssociationKey?: Order_By | null | undefined;
  DateBirthKey?: Order_By | null | undefined;
  DateCounselKey?: Order_By | null | undefined;
  DateHireAdjustedKey?: Order_By | null | undefined;
  DateHireKey?: Order_By | null | undefined;
  DateOfCounselKey?: Order_By | null | undefined;
  DatePartnershipKey?: Order_By | null | undefined;
  DateRehireExpirationKey?: Order_By | null | undefined;
  DateRehireKey?: Order_By | null | undefined;
  DateRemoteWorkingProgramKey?: Order_By | null | undefined;
  DateSeniorCounselKey?: Order_By | null | undefined;
  DateSpecialCounselKey?: Order_By | null | undefined;
  DateTermKey?: Order_By | null | undefined;
  DateinternationalPartnerKey?: Order_By | null | undefined;
  DimPersonnelNowKey?: Order_By | null | undefined;
  DiscoveryFlag?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  EliteTitleSortOrder?: Order_By | null | undefined;
  ElitedateHireKey?: Order_By | null | undefined;
  ElitedateTermKey?: Order_By | null | undefined;
  EmployeeIdOriginal?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  FullTimeEquivalency?: Order_By | null | undefined;
  IsActiveIndicator?: Order_By | null | undefined;
  LawsonCompany?: Order_By | null | undefined;
  LawsonFullTimeEquivalency?: Order_By | null | undefined;
  LawsondateHireAdjustedKey?: Order_By | null | undefined;
  LawsondateHireKey?: Order_By | null | undefined;
  LawsondateTermKey?: Order_By | null | undefined;
  Manager1EmployeeIdOriginal?: Order_By | null | undefined;
  Manager2EmployeeIdOriginal?: Order_By | null | undefined;
  Manager3EmployeeIdOriginal?: Order_By | null | undefined;
  Manager4EmployeeIdOriginal?: Order_By | null | undefined;
  Manager5EmployeeIdOriginal?: Order_By | null | undefined;
  Manager6EmployeeIdOriginal?: Order_By | null | undefined;
  MarsPersonID?: Order_By | null | undefined;
  MorganNetDisplayIndicator?: Order_By | null | undefined;
  PartnerTypeKey?: Order_By | null | undefined;
  RateBilling?: Order_By | null | undefined;
  RateGrid?: Order_By | null | undefined;
  RateStandard?: Order_By | null | undefined;
  Secretary1EmployeeIdOriginal?: Order_By | null | undefined;
  Secretary2EmployeeIdOriginal?: Order_By | null | undefined;
  StatusActiveEmployeeIndicator?: Order_By | null | undefined;
  TimekeeperIndex?: Order_By | null | undefined;
  WallBuilderEntityID?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "repl.DimPracticeGroupNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Practicegroup_Bool_Exp = {
  ActiveFlag?: String_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimPracticeGroupNowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  ETLModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlCheckSum?: Int_Mssql_Comparison_Exp | null | undefined;
  LawsonSubSubPracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeArea?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeAreaDelimited?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  PracticeGroupType?: String_Mssql_Comparison_Exp | null | undefined;
  SectionAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  SectionCode?: String_Mssql_Comparison_Exp | null | undefined;
  SectionName?: String_Mssql_Comparison_Exp | null | undefined;
  SubPracticeGroupAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  SubPracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  SubPracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  SubSubPracticeGroupAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  SubSubPracticeGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  SubSubPracticeGroupGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  SubSubPracticeGroupName?: String_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Practicegroup_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Practicegroup_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Practicegroup_Bool_Exp> | null | undefined;
  isActiveSubSubPracticeGroup?: Boolean_Mssql_Comparison_Exp | null | undefined;
  isDeleted?: Boolean_Mssql_Comparison_Exp | null | undefined;
  personnel_in_practicegroup?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** Ordering options when selecting data from "repl.DimPracticeGroupNow". */
export type Mlfsl_Practicegroup_Order_By = {
  ActiveFlag?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimPracticeGroupNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLCreatedDate?: Order_By | null | undefined;
  ETLModifiedDate?: Order_By | null | undefined;
  EtlCheckSum?: Order_By | null | undefined;
  LawsonSubSubPracticeGroupName?: Order_By | null | undefined;
  PracticeArea?: Order_By | null | undefined;
  PracticeAreaDelimited?: Order_By | null | undefined;
  PracticeGroupAbbreviation?: Order_By | null | undefined;
  PracticeGroupCode?: Order_By | null | undefined;
  PracticeGroupGUID?: Order_By | null | undefined;
  PracticeGroupName?: Order_By | null | undefined;
  PracticeGroupType?: Order_By | null | undefined;
  SectionAbbreviation?: Order_By | null | undefined;
  SectionCode?: Order_By | null | undefined;
  SectionName?: Order_By | null | undefined;
  SubPracticeGroupAbbreviation?: Order_By | null | undefined;
  SubPracticeGroupCode?: Order_By | null | undefined;
  SubPracticeGroupName?: Order_By | null | undefined;
  SubSubPracticeGroupAbbreviation?: Order_By | null | undefined;
  SubSubPracticeGroupCode?: Order_By | null | undefined;
  SubSubPracticeGroupGUID?: Order_By | null | undefined;
  SubSubPracticeGroupName?: Order_By | null | undefined;
  isActiveSubSubPracticeGroup?: Order_By | null | undefined;
  isDeleted?: Order_By | null | undefined;
  personnel_in_practicegroup_aggregate?: Mlfsl_Personnel_Aggregate_Order_By | null | undefined;
};

/** order by aggregate values of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Aggregate_Order_By = {
  avg?: Mlfsl_Probono_Goal_Avg_Order_By | null | undefined;
  count?: Order_By | null | undefined;
  max?: Mlfsl_Probono_Goal_Max_Order_By | null | undefined;
  min?: Mlfsl_Probono_Goal_Min_Order_By | null | undefined;
  stddev?: Mlfsl_Probono_Goal_Stddev_Order_By | null | undefined;
  stddev_pop?: Mlfsl_Probono_Goal_Stddev_Pop_Order_By | null | undefined;
  stddev_samp?: Mlfsl_Probono_Goal_Stddev_Samp_Order_By | null | undefined;
  sum?: Mlfsl_Probono_Goal_Sum_Order_By | null | undefined;
  var_pop?: Mlfsl_Probono_Goal_Var_Pop_Order_By | null | undefined;
  var_samp?: Mlfsl_Probono_Goal_Var_Samp_Order_By | null | undefined;
  variance?: Mlfsl_Probono_Goal_Variance_Order_By | null | undefined;
};

/** order by avg() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Avg_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "Finance.ProbonoGoalExport". All fields are combined with a logical 'AND'. */
export type Mlfsl_Probono_Goal_Bool_Exp = {
  DateofRun?: Datetime2_Mssql_Comparison_Exp | null | undefined;
  EmployeeID?: String_Mssql_Comparison_Exp | null | undefined;
  FiscalYear?: Int_Mssql_Comparison_Exp | null | undefined;
  HasTKMetProBonoGoalasofNow?: String_Mssql_Comparison_Exp | null | undefined;
  HoursToMeetGoal?: Float_Mssql_Comparison_Exp | null | undefined;
  NetworkID?: String_Mssql_Comparison_Exp | null | undefined;
  NumberofProBonoHours?: Float_Mssql_Comparison_Exp | null | undefined;
  ProBonoGoal?: Float_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Probono_Goal_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Probono_Goal_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Probono_Goal_Bool_Exp> | null | undefined;
  user?: Mlfsl_Personnel_Bool_Exp | null | undefined;
};

/** order by max() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Max_Order_By = {
  DateofRun?: Order_By | null | undefined;
  EmployeeID?: Order_By | null | undefined;
  FiscalYear?: Order_By | null | undefined;
  HasTKMetProBonoGoalasofNow?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NetworkID?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by min() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Min_Order_By = {
  DateofRun?: Order_By | null | undefined;
  EmployeeID?: Order_By | null | undefined;
  FiscalYear?: Order_By | null | undefined;
  HasTKMetProBonoGoalasofNow?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NetworkID?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by stddev() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Stddev_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by stddev_pop() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Stddev_Pop_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by stddev_samp() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Stddev_Samp_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by sum() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Sum_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by var_pop() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Var_Pop_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by var_samp() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Var_Samp_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** order by variance() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Variance_Order_By = {
  FiscalYear?: Order_By | null | undefined;
  HoursToMeetGoal?: Order_By | null | undefined;
  NumberofProBonoHours?: Order_By | null | undefined;
  ProBonoGoal?: Order_By | null | undefined;
};

/** Boolean expression to filter rows from the table "MLG.RelatedClient". All fields are combined with a logical 'AND'. */
export type Mlfsl_Related_Client_Bool_Exp = {
  AdministrativeFlag?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress1?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress2?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress3?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress4?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress5?: String_Mssql_Comparison_Exp | null | undefined;
  ClientAddress6?: String_Mssql_Comparison_Exp | null | undefined;
  ClientArrangementCode?: String_Mssql_Comparison_Exp | null | undefined;
  ClientArrangementCodeDescription?: String_Mssql_Comparison_Exp | null | undefined;
  ClientCity?: String_Mssql_Comparison_Exp | null | undefined;
  ClientClosedDate?: Mlfsl_Date_Bool_Exp | null | undefined;
  ClientContact?: String_Mssql_Comparison_Exp | null | undefined;
  ClientCountry?: String_Mssql_Comparison_Exp | null | undefined;
  ClientGUID?: Uniqueidentifier_Mssql_Comparison_Exp | null | undefined;
  ClientIndex?: Int_Mssql_Comparison_Exp | null | undefined;
  ClientName1?: String_Mssql_Comparison_Exp | null | undefined;
  ClientName2?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNameDisplay?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumberGroupCodeInd?: Boolean_Mssql_Comparison_Exp | null | undefined;
  ClientNumberIwov?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumberNoGroupCode?: String_Mssql_Comparison_Exp | null | undefined;
  ClientNumberWithDash?: String_Mssql_Comparison_Exp | null | undefined;
  ClientOpenDate?: Mlfsl_Date_Bool_Exp | null | undefined;
  ClientPhoneNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientPricingNarrative?: String_Mssql_Comparison_Exp | null | undefined;
  ClientReferredBy?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSortName?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSourceAbbreviation?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSourceName?: String_Mssql_Comparison_Exp | null | undefined;
  ClientSourceNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ClientState?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusCode?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusCodeActive?: String_Mssql_Comparison_Exp | null | undefined;
  ClientStatusDescription?: String_Mssql_Comparison_Exp | null | undefined;
  ClientZipCode?: String_Mssql_Comparison_Exp | null | undefined;
  Clients?: Mlfsl_Client_Bool_Exp | null | undefined;
  Confidential?: String_Mssql_Comparison_Exp | null | undefined;
  ConflictsAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  ConflictsAttorneyTKID?: String_Mssql_Comparison_Exp | null | undefined;
  CoordinatingResponsibleAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  CoordinatingResponsibleAttorneyTKID?: String_Mssql_Comparison_Exp | null | undefined;
  DateClientClosed?: Int_Mssql_Comparison_Exp | null | undefined;
  DateClientOpen?: Int_Mssql_Comparison_Exp | null | undefined;
  DeletedRecordIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  DimClientNowKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLBatchKey?: Int_Mssql_Comparison_Exp | null | undefined;
  ETLSoftInsertIndicator?: String_Mssql_Comparison_Exp | null | undefined;
  EtlChecksum?: Int_Mssql_Comparison_Exp | null | undefined;
  EtlCreatedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  EtlModifiedDate?: Datetime_Mssql_Comparison_Exp | null | undefined;
  IndustryDescription?: String_Mssql_Comparison_Exp | null | undefined;
  InventoryExceptionCode?: String_Mssql_Comparison_Exp | null | undefined;
  InventoryExceptionDescription?: String_Mssql_Comparison_Exp | null | undefined;
  IsClientAllianceProgram?: Int_Mssql_Comparison_Exp | null | undefined;
  LocationCode?: String_Mssql_Comparison_Exp | null | undefined;
  MatterStop?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClientName?: String_Mssql_Comparison_Exp | null | undefined;
  RelatedClientNumber?: String_Mssql_Comparison_Exp | null | undefined;
  ResponsibleAttorney?: Mlfsl_Personnel_Bool_Exp | null | undefined;
  ResponsibleAttorneyTkId?: String_Mssql_Comparison_Exp | null | undefined;
  SecureAlliManageMatterWorkspacesFlag?: String_Mssql_Comparison_Exp | null | undefined;
  SegmentDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SicCodeAndDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SicDescription?: String_Mssql_Comparison_Exp | null | undefined;
  SicTypeCode?: String_Mssql_Comparison_Exp | null | undefined;
  WallBuilderEntityId?: Int_Mssql_Comparison_Exp | null | undefined;
  _and?: Array<Mlfsl_Related_Client_Bool_Exp> | null | undefined;
  _not?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
  _or?: Array<Mlfsl_Related_Client_Bool_Exp> | null | undefined;
  mlfsl_finance_hours_clientofficetimeframes?: Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_clientpgtimeframes?: Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_clienttimeframes?: Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_clienttimekeepertimeframes?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_matterofficetimeframes?: Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_matterpgtimeframes?: Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimeframecompares?: Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp | null | undefined;
  mlfsl_finance_hours_mattertimeframes?: Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_relatedclientofficetimeframes?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_relatedclientpgtimeframes?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_relatedclienttimeframe?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp | null | undefined;
  mlfsl_finance_hours_relatedclienttimekeepertimeframes?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp | null | undefined;
  mlfsl_mlv_finance_hours_relatedclient?: Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp | null | undefined;
};

/** Ordering options when selecting data from "MLG.RelatedClient". */
export type Mlfsl_Related_Client_Order_By = {
  AdministrativeFlag?: Order_By | null | undefined;
  ClientAddress1?: Order_By | null | undefined;
  ClientAddress2?: Order_By | null | undefined;
  ClientAddress3?: Order_By | null | undefined;
  ClientAddress4?: Order_By | null | undefined;
  ClientAddress5?: Order_By | null | undefined;
  ClientAddress6?: Order_By | null | undefined;
  ClientArrangementCode?: Order_By | null | undefined;
  ClientArrangementCodeDescription?: Order_By | null | undefined;
  ClientCity?: Order_By | null | undefined;
  ClientClosedDate?: Mlfsl_Date_Order_By | null | undefined;
  ClientContact?: Order_By | null | undefined;
  ClientCountry?: Order_By | null | undefined;
  ClientGUID?: Order_By | null | undefined;
  ClientIndex?: Order_By | null | undefined;
  ClientName1?: Order_By | null | undefined;
  ClientName2?: Order_By | null | undefined;
  ClientNameDisplay?: Order_By | null | undefined;
  ClientNumber?: Order_By | null | undefined;
  ClientNumberGroupCodeInd?: Order_By | null | undefined;
  ClientNumberIwov?: Order_By | null | undefined;
  ClientNumberNoGroupCode?: Order_By | null | undefined;
  ClientNumberWithDash?: Order_By | null | undefined;
  ClientOpenDate?: Mlfsl_Date_Order_By | null | undefined;
  ClientPhoneNumber?: Order_By | null | undefined;
  ClientPricingNarrative?: Order_By | null | undefined;
  ClientReferredBy?: Order_By | null | undefined;
  ClientSortName?: Order_By | null | undefined;
  ClientSourceAbbreviation?: Order_By | null | undefined;
  ClientSourceName?: Order_By | null | undefined;
  ClientSourceNumber?: Order_By | null | undefined;
  ClientState?: Order_By | null | undefined;
  ClientStatusCode?: Order_By | null | undefined;
  ClientStatusCodeActive?: Order_By | null | undefined;
  ClientStatusDescription?: Order_By | null | undefined;
  ClientZipCode?: Order_By | null | undefined;
  Clients_aggregate?: Mlfsl_Client_Aggregate_Order_By | null | undefined;
  Confidential?: Order_By | null | undefined;
  ConflictsAttorney?: Mlfsl_Personnel_Order_By | null | undefined;
  ConflictsAttorneyTKID?: Order_By | null | undefined;
  CoordinatingResponsibleAttorney?: Mlfsl_Personnel_Order_By | null | undefined;
  CoordinatingResponsibleAttorneyTKID?: Order_By | null | undefined;
  DateClientClosed?: Order_By | null | undefined;
  DateClientOpen?: Order_By | null | undefined;
  DeletedRecordIndicator?: Order_By | null | undefined;
  DimClientNowKey?: Order_By | null | undefined;
  ETLBatchKey?: Order_By | null | undefined;
  ETLSoftInsertIndicator?: Order_By | null | undefined;
  EtlChecksum?: Order_By | null | undefined;
  EtlCreatedDate?: Order_By | null | undefined;
  EtlModifiedDate?: Order_By | null | undefined;
  IndustryDescription?: Order_By | null | undefined;
  InventoryExceptionCode?: Order_By | null | undefined;
  InventoryExceptionDescription?: Order_By | null | undefined;
  IsClientAllianceProgram?: Order_By | null | undefined;
  LocationCode?: Order_By | null | undefined;
  MatterStop?: Order_By | null | undefined;
  RelatedClientName?: Order_By | null | undefined;
  RelatedClientNumber?: Order_By | null | undefined;
  ResponsibleAttorney?: Mlfsl_Personnel_Order_By | null | undefined;
  ResponsibleAttorneyTkId?: Order_By | null | undefined;
  SecureAlliManageMatterWorkspacesFlag?: Order_By | null | undefined;
  SegmentDescription?: Order_By | null | undefined;
  SicCodeAndDescription?: Order_By | null | undefined;
  SicDescription?: Order_By | null | undefined;
  SicTypeCode?: Order_By | null | undefined;
  WallBuilderEntityId?: Order_By | null | undefined;
  mlfsl_finance_hours_clientofficetimeframes_aggregate?: Mlfsl_Finance_Hours_Clientofficetimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_clientpgtimeframes_aggregate?: Mlfsl_Finance_Hours_Clientpgtimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_clienttimeframes_aggregate?: Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_clienttimekeepertimeframes_aggregate?: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_matterofficetimeframes_aggregate?: Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_matterpgtimeframes_aggregate?: Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_mattertimeframecompares_aggregate?: Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_mattertimeframes_aggregate?: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_relatedclientofficetimeframes_aggregate?: Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_relatedclientpgtimeframes_aggregate?: Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_relatedclienttimeframe_aggregate?: Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_finance_hours_relatedclienttimekeepertimeframes_aggregate?: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_Order_By | null | undefined;
  mlfsl_mlv_finance_hours_relatedclient?: Mlfsl_Mlv_Finance_Hours_Relatedclient_Order_By | null | undefined;
};

/** column ordering options */
export type Order_By =
  /** in ascending order, nulls last */
  | 'asc'
  /** in ascending order, nulls first */
  | 'asc_nulls_first'
  /** in ascending order, nulls last */
  | 'asc_nulls_last'
  /** in descending order, nulls first */
  | 'desc'
  /** in descending order, nulls first */
  | 'desc_nulls_first'
  /** in descending order, nulls last */
  | 'desc_nulls_last';

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to compare columns of type "uniqueidentifier". All fields are combined with logical 'AND'. */
export type Uniqueidentifier_Mssql_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to compare columns of type "varbinary". All fields are combined with logical 'AND'. */
export type Varbinary_Mssql_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { me: { displayName: string | null, givenName: string | null, surname: string | null, jobTitle: string | null, businessPhones: Array<string> | null, mobilePhone: string | null, officeLocation: string | null, userPrincipalName: string | null, id: string | null, mail: string | null, preferredLanguage: string | null, images: { large: string | null, medium: string | null, small: string | null } } | null };

export type SearchUserQueryVariables = Exact<{
  searchString: string;
  limit?: number | null | undefined;
}>;


export type SearchUserQuery = { mlfsl_personnel: Array<{ NamePreferredDisplay: string | null, Email: string | null, ActiveDirectoryLogin: string | null, BusinessPrimaryOfficePhoneNumberFull: string | null, TitleFullyQualified: string | null, BusinessPrimaryOfficeAddress1: string | null, BusinessPrimaryOffice: string | null, PrimaryPracticeGroup: { PracticeGroupName: string | null } | null }> };

export type GetFilteredClientRecordsQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  order_by?: Array<Mlfsl_Client_Order_By> | Mlfsl_Client_Order_By | null | undefined;
  where?: Mlfsl_Client_Bool_Exp | null | undefined;
}>;


export type GetFilteredClientRecordsQuery = { mlfsl_client: Array<{ ClientName1: string | null, ClientNumber: string, DateClientClosed: number | null, DateClientOpen: number | null, ResponsibleAttorney: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null, TitleFullyQualified: string | null, BusinessPrimaryOfficePhoneNumberFull: string | null, BusinessPrimaryOffice: string | null, PrimaryPracticeGroup: { SubSubPracticeGroupName: string | null } | null } | null, cmap_clm_engagement_record: { id: string, created_at: string, type: string, updated_at: string, created_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null, TitleFullyQualified: string | null, BusinessPrimaryOfficePhoneNumberFull: string | null, BusinessPrimaryOffice: string | null, PrimaryPracticeGroup: { PracticeGroupName: string | null } | null } | null, updated_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null, TitleFullyQualified: string | null, BusinessPrimaryOfficePhoneNumberFull: string | null, BusinessPrimaryOffice: string | null, PrimaryPracticeGroup: { PracticeGroupName: string | null } | null } | null, engagement_client_comments: Array<{ id: string, comments: string, updated_at: string, created_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null, TitleFullyQualified: string | null, BusinessPrimaryOfficePhoneNumberFull: string | null, BusinessPrimaryOffice: string | null, PrimaryPracticeGroup: { PracticeGroupName: string | null } | null } | null, updated_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null, TitleFullyQualified: string | null, PrimaryPracticeGroup: { PracticeGroupName: string | null } | null } | null }>, engagement_imanage_documents: Array<{ id: string, doc_id: string, name: string, updated_at: string, updated_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null, TitleFullyQualified: string | null, PrimaryPracticeGroup: { PracticeGroupName: string | null } | null } | null }> } | null }> };

export type GetClientRecordsListQueryVariables = Exact<{
  limit?: number | null | undefined;
  where?: Mlfsl_Client_Bool_Exp | null | undefined;
}>;


export type GetClientRecordsListQuery = { mlfsl_client: Array<{ ClientName1: string | null, ClientNumber: string, DateClientClosed: number | null, DateClientOpen: number | null, ResponsibleAttorney: { NamePreferredFull: string | null, PrimaryPracticeGroup: { SubSubPracticeGroupName: string | null } | null } | null }> };

export type GetRelatedClientsListQueryVariables = Exact<{
  limit?: number | null | undefined;
  where?: Mlfsl_Related_Client_Bool_Exp | null | undefined;
}>;


export type GetRelatedClientsListQuery = { mlfsl_related_client: Array<{ RelatedClientName: string | null, RelatedClientNumber: string | null, Clients: Array<{ ClientName1: string | null, ClientNumber: string }> }> };

export type GetRelatedClientsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRelatedClientsCountQuery = { mlfsl_client_aggregate: { aggregate: { count: number } | null } };

export type GetEngagementRecordsListQueryVariables = Exact<{
  limit?: number | null | undefined;
  where?: Clm_Engagement_Records_Bool_Exp | null | undefined;
}>;


export type GetEngagementRecordsListQuery = { clm_engagement_records: Array<{ id: string, client_number: string, created_at: string, updated_at: string, engagement_imanage_documents: Array<{ doc_id: string }> }> };

export type GetPaginatedDocumentsQueryVariables = Exact<{
  clientNumber: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  where?: Clm_Engagement_Imanage_Documents_Bool_Exp | null | undefined;
}>;


export type GetPaginatedDocumentsQuery = { mlfsl_client: Array<{ cmap_clm_engagement_record: { engagement_imanage_documents_aggregate: { aggregate: { count: number } | null }, engagement_imanage_documents: Array<{ id: string, doc_id: string, name: string }> } | null }> };

export type GetWaiverRecordsListQueryVariables = Exact<{
  limit?: number | null | undefined;
  where?: Clm_Waiver_Records_Bool_Exp | null | undefined;
}>;


export type GetWaiverRecordsListQuery = { clm_waiver_records: Array<{ id: string, matter_number: string | null, client_number: string | null, adverse_client_name: string | null, adverse_contact_signer: string | null, adverse_letter_date: string | null, adverse_mlb_attorney_on_letter_name: string | null, client_contact: string | null, client_letter_date: string | null, mlb_attorney_on_client_letter_name: string | null, multiple_waivers: string | null, mlfsl_client: { ClientName1: string | null } | null }> };

export type GetPaginatedWaiverDocumentsQueryVariables = Exact<{
  waiverRecordId: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  where?: Clm_Waiver_Imanage_Documents_Bool_Exp | null | undefined;
}>;


export type GetPaginatedWaiverDocumentsQuery = { clm_waiver_records: Array<{ waiver_imanage_documents_aggregate: { aggregate: { count: number } | null }, waiver_imanage_documents: Array<{ id: string, doc_id: string, name: string, created_at: string, updated_at: string, waiver_records_id: string }> }> };

export type GetWaiverRecordQueryVariables = Exact<{
  waiver_id: string;
}>;


export type GetWaiverRecordQuery = { clm_waiver_records_by_pk: { id: string, matter_number: string | null, client_number: string | null, client_contact: string | null, client_letter_date: string | null, mlb_attorney_on_client_letter_name: string | null, adverse_mlb_attorney_on_letter_name: string | null, adverse_client_name: string | null, adverse_contact_signer: string | null, adverse_letter_date: string | null, multiple_waivers: string | null, comments: string | null, created_at: string, updated_at: string, created_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null } | null, updated_by_user: { ActiveDirectoryLogin: string | null, NamePreferredFull: string | null, Email: string | null } | null, mlfsl_client: { ClientName1: string | null } | null } | null };


export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhones"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocation"}},{"kind":"Field","name":{"kind":"Name","value":"userPrincipalName"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mail"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const SearchUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlfsl_personnel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"NamePreferredDisplay"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ActiveDirectoryDisabledIndicator"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"N","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NamePreferredDisplay"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOfficePhoneNumberFull"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOfficeAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOffice"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PracticeGroupName"}}]}}]}}]}}]} as unknown as DocumentNode<SearchUserQuery, SearchUserQueryVariables>;
export const GetFilteredClientRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredClientRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mlfsl_client_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ClientName1"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mlfsl_client_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlfsl_client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientName1"}},{"kind":"Field","name":{"kind":"Name","value":"ClientNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ResponsibleAttorney"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SubSubPracticeGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOfficePhoneNumberFull"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOffice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"DateClientClosed"}},{"kind":"Field","name":{"kind":"Name","value":"DateClientOpen"}},{"kind":"Field","name":{"kind":"Name","value":"cmap_clm_engagement_record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PracticeGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOfficePhoneNumberFull"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOffice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PracticeGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOfficePhoneNumberFull"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOffice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement_client_comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PracticeGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOfficePhoneNumberFull"}},{"kind":"Field","name":{"kind":"Name","value":"BusinessPrimaryOffice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PracticeGroupName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement_imanage_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"TitleFullyQualified"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PracticeGroupName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFilteredClientRecordsQuery, GetFilteredClientRecordsQueryVariables>;
export const GetClientRecordsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientRecordsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10000"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mlfsl_client_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlfsl_client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ClientNumber"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientName1"}},{"kind":"Field","name":{"kind":"Name","value":"ClientNumber"}},{"kind":"Field","name":{"kind":"Name","value":"DateClientClosed"}},{"kind":"Field","name":{"kind":"Name","value":"DateClientOpen"}},{"kind":"Field","name":{"kind":"Name","value":"ResponsibleAttorney"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryPracticeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SubSubPracticeGroupName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetClientRecordsListQuery, GetClientRecordsListQueryVariables>;
export const GetRelatedClientsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelatedClientsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10000"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mlfsl_related_client_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlfsl_related_client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RelatedClientName"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RelatedClientName"}},{"kind":"Field","name":{"kind":"Name","value":"RelatedClientNumber"}},{"kind":"Field","name":{"kind":"Name","value":"Clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientName1"}},{"kind":"Field","name":{"kind":"Name","value":"ClientNumber"}}]}}]}}]}}]} as unknown as DocumentNode<GetRelatedClientsListQuery, GetRelatedClientsListQueryVariables>;
export const GetRelatedClientsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelatedClientsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlfsl_client_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RelatedClientNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"RelatedClientNumber"}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]}}]} as unknown as DocumentNode<GetRelatedClientsCountQuery, GetRelatedClientsCountQueryVariables>;
export const GetEngagementRecordsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEngagementRecordsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10000"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"clm_engagement_records_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clm_engagement_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"engagement_imanage_documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetEngagementRecordsListQuery, GetEngagementRecordsListQueryVariables>;
export const GetPaginatedDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaginatedDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"clm_engagement_imanage_documents_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mlfsl_client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ClientNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientNumber"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmap_clm_engagement_record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement_imanage_documents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement_imanage_documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPaginatedDocumentsQuery, GetPaginatedDocumentsQueryVariables>;
export const GetWaiverRecordsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWaiverRecordsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20000"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"clm_waiver_records_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clm_waiver_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matter_number"}},{"kind":"Field","name":{"kind":"Name","value":"client_number"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_client_name"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_contact_signer"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_letter_date"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_mlb_attorney_on_letter_name"}},{"kind":"Field","name":{"kind":"Name","value":"client_contact"}},{"kind":"Field","name":{"kind":"Name","value":"client_letter_date"}},{"kind":"Field","name":{"kind":"Name","value":"mlb_attorney_on_client_letter_name"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_waivers"}},{"kind":"Field","name":{"kind":"Name","value":"mlfsl_client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientName1"}}]}}]}}]}}]} as unknown as DocumentNode<GetWaiverRecordsListQuery, GetWaiverRecordsListQueryVariables>;
export const GetPaginatedWaiverDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaginatedWaiverDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waiverRecordId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"clm_waiver_imanage_documents_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clm_waiver_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waiverRecordId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waiver_imanage_documents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"waiver_imanage_documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"waiver_records_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetPaginatedWaiverDocumentsQuery, GetPaginatedWaiverDocumentsQueryVariables>;
export const GetWaiverRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWaiverRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waiver_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clm_waiver_records_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waiver_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matter_number"}},{"kind":"Field","name":{"kind":"Name","value":"client_number"}},{"kind":"Field","name":{"kind":"Name","value":"client_contact"}},{"kind":"Field","name":{"kind":"Name","value":"client_letter_date"}},{"kind":"Field","name":{"kind":"Name","value":"mlb_attorney_on_client_letter_name"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_mlb_attorney_on_letter_name"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_client_name"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_contact_signer"}},{"kind":"Field","name":{"kind":"Name","value":"adverse_letter_date"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_waivers"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActiveDirectoryLogin"}},{"kind":"Field","name":{"kind":"Name","value":"NamePreferredFull"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mlfsl_client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ClientName1"}}]}}]}}]}}]} as unknown as DocumentNode<GetWaiverRecordQuery, GetWaiverRecordQueryVariables>;